
/* CARDWORLD Rip Studio - startscherm van de feed (scene 0), concept 4 "Budget eerst"
   window.CWStart = { html(ctx), mount(root, ctx), replay(root), unmount(root) }
   Geen afhankelijkheden. Enkel transform/opacity animeren (plus de breedte van de vulbalk,
   de schuivende schakelaar-markering, een korte achtergrond-position-drift en getallen die
   tellen via textContent), allemaal goedkoop, geen blur. */
(function () {
  'use strict';

  /* ---------------- i18n ---------------- */
  var STR = {
    nl: {
      morning: 'Goedemorgen', afternoon: 'Goedemiddag', evening: 'Goedenavond',
      budgetLabel: 'Jouw budget',
      budgetAria: 'Budget',
      budgetEditAria: 'Budget bewerken',
      customAria: 'Eigen bedrag, tussen 10 en 2000 euro',
      customConfirmAria: 'Bevestigen',
      customHint: 'Tussen € 10 en € 2.000',
      customStepLabel: 'Eigen',
      franchise3: { mix: 'Alles', pokemon: 'Pokémon', one_piece: 'One Piece', andere: 'Andere TCG' },
      addMany: 'Zet in mandje',
      added: 'In je mandje',
      refreshLabel: 'Andere selectie',
      refreshAria: 'Andere selectie',
      onlyOne: 'Dit is de enige combinatie binnen je budget',
      scrollLabel: 'Liever zelf kiezen? Scroll naar alle producten',
      emptyTitle: 'Kies je budget',
      noMatch: 'Nog geen match voor dit budget',
      buyKicker: 'Jouw selectie',
      buyCount: function (n) { return n === 1 ? '1 product' : n + ' producten'; },
      buyTotalLabel: 'Totaal',
      buyEmptyLine: function (price) { return 'Kies een budget vanaf ' + eurPlainNL(price) + '.'; },
      carEmptyTitle: 'Nog niks binnen dit budget',
      carEmptyText: function (fLabel, price) { return fLabel + ' begint bij ' + eurPlainNL(price) + '.'; },
      carSetMin: function (price) { return 'Zet budget op ' + eurWholeNL(price); },
      carShowMix: 'Toon alles',
      carEmptyPeek: 'Goedkoopste in deze franchise',
      cardAria: function (title) { return 'Open ' + title; },
      carPrev: 'Vorige producten', carNext: 'Volgende producten',
      prefsBtn: 'Voorkeuren',
      prefsAria: 'Voorkeuren voor producttype',
      prefsAuto: 'Laat CARDIX kiezen',
      prefsAutoSub: 'Op basis van wat je eerder kocht en bekeek',
      prefsDone: 'Klaar',
      prefsCloseAria: 'Sluiten',
      prefsJoinWord: 'en',
      prefsSecWho: 'Wie kiest?', prefsWhoSelf: 'Zelf kiezen', prefsWhoSelfSub: 'Jij stelt de opties zelf in',
      prefsSecTypes: 'Wat open je het liefst?', prefsAll: 'Alles',
      prefsSecStyle: 'Hoe stel je samen?', prefsStyle: { packs: 'Veel packs', mixed: 'Gemengd', big: 'Eén groot stuk' },
      prefsSecPurpose: 'Waarvoor is het?', prefsPurpose: { stream: 'Openen op stream', seal: 'Sealed bewaren', gift: 'Cadeau' },
      prefsSecSmart: 'Slim', prefsAvoid: 'Vermijd wat ik al kocht',
      prefsReset: 'Herstel standaard',
      prefsSumWho: { cardix: 'CARDIX kiest', manual: 'Zelf gekozen' },
      prefsSumTypes: function (list) { return 'vooral ' + list; },
      prefsSumMix: 'een gevarieerde mix',
      prefsSumStyle: { packs: 'veel packs', big: 'een groot stuk' },
      prefsSumPurpose: { stream: 'om te openen', seal: 'om te bewaren', gift: 'als cadeau' },
      prefCat: {
        packs: 'Booster packs', blister: 'Sleeved / blister packs', bundles: 'Bundels',
        etb: 'Elite Trainer Boxen', boxen: 'Booster boxen', collecties: 'Collecties en tins', cases: 'Displays of cases'
      },
      prefsLineManual: function (list) { return 'Vooral ' + list + '.'; },
      prefsLineCardix: function (list) { return 'CARDIX kiest: vooral ' + list + ', zoals je vorige keren.'; },
      prefsLineAuto: 'CARDIX kiest een gevarieerde mix.',
      /* eigenaar 5 okt: "geen ... hier is een alternatief" leek te zeggen dat er niets was, terwijl er producten staan.
         Nu met de echte instapprijs, of (niets in voorraad bij deze franchise) zonder bedrag. */
      prefsFallbackLine: function (list, from) { return from != null ? list + ' beginnen bij ' + eurPlainNL(from) + '. Dit past wel in je budget:' : 'Geen ' + lowerFirst(list) + ' in voorraad bij deze keuze. Dit past wel in je budget:'; },
      prefsRaised: function (list, from) { return 'Je budget staat nu op ' + eurPlainNL(from) + ', zodat er ' + lowerSmart(list) + ' in passen.'; },
      removeAria: 'Verwijderen',
      replaceAria: 'Vervangen',
      replaceNoAlt: 'Geen alternatief binnen je budget',
      qtyMinusAria: 'Aantal verlagen',
      qtyPlusAria: 'Aantal verhogen',
      addChip: 'Voeg toe',
      addChipAria: 'Zelf een product toevoegen',
      addTitle: 'Voeg toe',
      addSearchPh: 'Zoek op naam, set, franchise of soort',
      addSearchAria: 'Zoek een product',
      addPlusAria: function (title) { return 'Voeg ' + title + ' toe'; },
      addEmpty: 'Geen producten gevonden',
      addAllFr: 'Alle franchises', addAllKinds: 'Alle soorten',
      addCount: function (n) { return n === 1 ? '1 product' : n + ' producten'; },
      overBudgetChip: 'Boven je budget', boughtChip: 'Eerder gekocht',
      overBudgetLine: function (amount) { return eurPlainNL(amount) + ' boven je budget'; },
      manualLine: 'Je hebt je selectie aangepast',
      manualRestore: 'Herstel voorstel',
      /* bevestiging na "Zet in mandje" (eigenaar 6 okt): titel hergebruikt t.added ("In je
         mandje"), zelfde woord als op de knop zelf */
      confirmLine: function (n, total) { return (n === 1 ? '1 product' : n + ' producten') + ', ' + eurPlainNL(total); },
      confirmNewBtn: 'Stel een nieuwe samen',
      confirmCartBtn: 'Bekijk mijn mandje',
      confirmUndo: 'Ongedaan maken'
    },
    fr: {
      morning: 'Bonjour', afternoon: 'Bon après-midi', evening: 'Bonsoir',
      budgetLabel: 'Ton budget',
      budgetAria: 'Budget',
      budgetEditAria: 'Modifier le budget',
      customAria: 'Montant libre, entre 10 et 2000 euros',
      customConfirmAria: 'Confirmer',
      customHint: 'Entre € 10 et € 2.000',
      customStepLabel: 'Libre',
      franchise3: { mix: 'Tout', pokemon: 'Pokémon', one_piece: 'One Piece', andere: 'Autres TCG' },
      addMany: 'Mettre au panier',
      added: 'Dans ton panier',
      refreshLabel: 'Autre sélection',
      refreshAria: 'Autre sélection',
      onlyOne: 'C’est la seule combinaison possible avec ce budget',
      scrollLabel: 'Tu préfères choisir toi-même ? Défile vers tous les produits',
      emptyTitle: 'Choisis ton budget',
      noMatch: 'Pas encore de match pour ce budget',
      buyKicker: 'Ta sélection',
      buyCount: function (n) { return n === 1 ? '1 produit' : n + ' produits'; },
      buyTotalLabel: 'Total',
      buyEmptyLine: function (price) { return 'Choisis un budget à partir de ' + eurPlainNL(price) + '.'; },
      carEmptyTitle: 'Rien encore dans ce budget',
      carEmptyText: function (fLabel, price) { return fLabel + ' commence à ' + eurPlainNL(price) + '.'; },
      carSetMin: function (price) { return 'Mettre le budget à ' + eurWholeNL(price); },
      carShowMix: 'Tout montrer',
      carEmptyPeek: 'Le moins cher de cette franchise',
      cardAria: function (title) { return 'Ouvrir ' + title; },
      carPrev: 'Produits précédents', carNext: 'Produits suivants',
      prefsBtn: 'Préférences',
      prefsAria: 'Préférences de type de produit',
      prefsAuto: 'Laisser CARDIX choisir',
      prefsAutoSub: 'Selon ce que tu as déjà acheté et consulté',
      prefsDone: 'Terminé',
      prefsCloseAria: 'Fermer',
      prefsJoinWord: 'et',
      prefsSecWho: 'Qui choisit ?', prefsWhoSelf: 'Choisir moi-même', prefsWhoSelfSub: 'Tu règles les options toi-même',
      prefsSecTypes: 'Que préfères-tu ouvrir ?', prefsAll: 'Tout',
      prefsSecStyle: 'Comment composer ?', prefsStyle: { packs: 'Beaucoup de packs', mixed: 'Mixte', big: 'Une grosse pièce' },
      prefsSecPurpose: 'C\'est pour quoi ?', prefsPurpose: { stream: 'Ouvrir en stream', seal: 'Garder sealed', gift: 'Cadeau' },
      prefsSecSmart: 'Malin', prefsAvoid: 'Éviter ce que j\'ai déjà acheté',
      prefsReset: 'Rétablir par défaut',
      prefsSumWho: { cardix: 'CARDIX choisit', manual: 'Choix perso' },
      prefsSumTypes: function (list) { return 'surtout ' + list; },
      prefsSumMix: 'un mix varié',
      prefsSumStyle: { packs: 'beaucoup de packs', big: 'une grosse pièce' },
      prefsSumPurpose: { stream: 'pour ouvrir', seal: 'pour garder', gift: 'en cadeau' },
      prefCat: {
        packs: 'Boosters', blister: 'Blisters', bundles: 'Lots',
        etb: 'Elite Trainer Box', boxen: 'Boîtes de boosters', collecties: 'Coffrets et tins', cases: 'Displays ou caisses'
      },
      prefsLineManual: function (list) { return 'Surtout ' + list + '.'; },
      prefsLineCardix: function (list) { return 'CARDIX choisit : surtout ' + list + ', comme les fois précédentes.'; },
      prefsLineAuto: 'CARDIX choisit un mix varié.',
      prefsFallbackLine: function (list, from) { return from != null ? list + ' à partir de ' + eurPlainNL(from) + '. Ceci rentre dans ton budget :' : 'Pas de ' + lowerFirst(list) + ' en stock pour ce choix. Ceci rentre dans ton budget :'; },
      prefsRaised: function (list, from) { return 'Ton budget passe à ' + eurPlainNL(from) + ' pour que des ' + lowerSmart(list) + ' y rentrent.'; },
      removeAria: 'Supprimer',
      replaceAria: 'Remplacer',
      replaceNoAlt: 'Pas d’alternative dans ton budget',
      qtyMinusAria: 'Diminuer la quantité',
      qtyPlusAria: 'Augmenter la quantité',
      addChip: 'Ajouter',
      addChipAria: 'Ajouter un produit toi-même',
      addTitle: 'Ajouter',
      addSearchPh: 'Nom, set, franchise ou type',
      addSearchAria: 'Chercher un produit',
      addPlusAria: function (title) { return 'Ajouter ' + title; },
      addEmpty: 'Aucun produit trouvé',
      addAllFr: 'Toutes les franchises', addAllKinds: 'Tous les types',
      addCount: function (n) { return n === 1 ? '1 produit' : n + ' produits'; },
      overBudgetChip: 'Au dessus de ton budget', boughtChip: 'Déjà acheté',
      overBudgetLine: function (amount) { return eurPlainNL(amount) + ' au dessus de ton budget'; },
      manualLine: 'Tu as modifié ta sélection',
      manualRestore: 'Restaurer la proposition',
      confirmLine: function (n, total) { return (n === 1 ? '1 produit' : n + ' produits') + ', ' + eurPlainNL(total); },
      confirmNewBtn: 'Compose une nouvelle sélection',
      confirmCartBtn: 'Voir mon panier',
      confirmUndo: 'Annuler'
    },
    en: {
      morning: 'Good morning', afternoon: 'Good afternoon', evening: 'Good evening',
      budgetLabel: 'Your budget',
      budgetAria: 'Budget',
      budgetEditAria: 'Edit budget',
      customAria: 'Custom amount, between 10 and 2000 euros',
      customConfirmAria: 'Confirm',
      customHint: 'Between € 10 and € 2,000',
      customStepLabel: 'Custom',
      franchise3: { mix: 'All', pokemon: 'Pokémon', one_piece: 'One Piece', andere: 'Other TCG' },
      addMany: 'Add to cart',
      added: 'In your cart',
      refreshLabel: 'Different pick',
      refreshAria: 'Different pick',
      onlyOne: 'This is the only combination within your budget',
      scrollLabel: 'Prefer to pick yourself? Scroll to all products',
      emptyTitle: 'Pick your budget',
      noMatch: 'No match for this budget yet',
      buyKicker: 'Your selection',
      buyCount: function (n) { return n === 1 ? '1 product' : n + ' products'; },
      buyTotalLabel: 'Total',
      buyEmptyLine: function (price) { return 'Pick a budget from ' + eurPlainNL(price) + '.'; },
      carEmptyTitle: 'Nothing in this budget yet',
      carEmptyText: function (fLabel, price) { return fLabel + ' starts at ' + eurPlainNL(price) + '.'; },
      carSetMin: function (price) { return 'Set budget to ' + eurWholeNL(price); },
      carShowMix: 'Show all',
      carEmptyPeek: 'Cheapest in this franchise',
      cardAria: function (title) { return 'Open ' + title; },
      carPrev: 'Previous products', carNext: 'Next products',
      prefsBtn: 'Preferences',
      prefsAria: 'Product type preferences',
      prefsAuto: 'Let CARDIX choose',
      prefsAutoSub: 'Based on what you bought and viewed before',
      prefsDone: 'Done',
      prefsCloseAria: 'Close',
      prefsJoinWord: 'and',
      prefsSecWho: 'Who chooses?', prefsWhoSelf: 'Choose myself', prefsWhoSelfSub: 'You set the options yourself',
      prefsSecTypes: 'What do you like to open most?', prefsAll: 'All',
      prefsSecStyle: 'How should we put it together?', prefsStyle: { packs: 'Lots of packs', mixed: 'Mixed', big: 'One big piece' },
      prefsSecPurpose: 'What is it for?', prefsPurpose: { stream: 'Open on stream', seal: 'Keep sealed', gift: 'Gift' },
      prefsSecSmart: 'Smart', prefsAvoid: 'Avoid what I already bought',
      prefsReset: 'Restore defaults',
      prefsSumWho: { cardix: 'CARDIX picks', manual: 'Your picks' },
      prefsSumTypes: function (list) { return 'mostly ' + list; },
      prefsSumMix: 'a varied mix',
      prefsSumStyle: { packs: 'lots of packs', big: 'one big piece' },
      prefsSumPurpose: { stream: 'to open', seal: 'to keep sealed', gift: 'as a gift' },
      prefCat: {
        packs: 'Booster packs', blister: 'Sleeved / blister packs', bundles: 'Bundles',
        etb: 'Elite Trainer Boxes', boxen: 'Booster boxes', collecties: 'Collections and tins', cases: 'Displays or cases'
      },
      prefsLineManual: function (list) { return 'Mostly ' + list + '.'; },
      prefsLineCardix: function (list) { return 'CARDIX picks: mostly ' + list + ', like your previous picks.'; },
      prefsLineAuto: 'CARDIX picks a varied mix.',
      prefsFallbackLine: function (list, from) { return from != null ? list + ' start at ' + eurPlainNL(from) + '. This fits your budget:' : 'No ' + lowerFirst(list) + ' in stock for this choice. This fits your budget:'; },
      prefsRaised: function (list, from) { return 'Your budget is now ' + eurPlainNL(from) + ' so ' + lowerSmart(list) + ' fit in.'; },
      removeAria: 'Remove',
      replaceAria: 'Replace',
      replaceNoAlt: 'No alternative within your budget',
      qtyMinusAria: 'Decrease quantity',
      qtyPlusAria: 'Increase quantity',
      addChip: 'Add',
      addChipAria: 'Add a product yourself',
      addTitle: 'Add',
      addSearchPh: 'Search by name, set, franchise or type',
      addSearchAria: 'Search a product',
      addPlusAria: function (title) { return 'Add ' + title; },
      addEmpty: 'No products found',
      addAllFr: 'All franchises', addAllKinds: 'All types',
      addCount: function (n) { return n === 1 ? '1 product' : n + ' products'; },
      overBudgetChip: 'Over your budget', boughtChip: 'Bought before',
      overBudgetLine: function (amount) { return eurPlainNL(amount) + ' over your budget'; },
      manualLine: 'You have adjusted your selection',
      manualRestore: 'Restore suggestion',
      confirmLine: function (n, total) { return (n === 1 ? '1 product' : n + ' products') + ', ' + eurPlainNL(total); },
      confirmNewBtn: 'Put together a new pick',
      confirmCartBtn: 'View my cart',
      confirmUndo: 'Undo'
    }
  };
  function strFor(lang) { return STR[lang] || STR.nl; }

  /* ---------------- iconen (inline, stroke currentColor) ---------------- */
  var ICONS = {
    check: '<path d="M5 13l4.5 4.5L19 8"></path>',
    arrowdown: '<path d="M12 4v15M6 13l6 6 6-6"></path>',
    refresh: '<path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path><path d="M21 3v5h-5"></path><path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path><path d="M3 21v-5h5"></path>',
    plus: '<path d="M12 5v14M5 12h14"></path>',
    chevl: '<path d="M15 5l-7 7 7 7"></path>',
    chevr: '<path d="M9 5l7 7-7 7"></path>',
    pencil: '<path d="M4 20h4L18.5 9.5a2.12 2.12 0 0 0-3-3L5 17v3z"></path><path d="M13.5 6.5l4 4"></path>',
    box: '<rect x="4" y="8" width="16" height="12" rx="2"></rect><path d="M4 8l8-4 8 4"></path><path d="M12 4v16"></path>',
    sliders: '<line x1="4" y1="6" x2="20" y2="6"></line><circle cx="9" cy="6" r="2.2"></circle><line x1="4" y1="12" x2="20" y2="12"></line><circle cx="15" cy="12" r="2.2"></circle><line x1="4" y1="18" x2="20" y2="18"></line><circle cx="11" cy="18" r="2.2"></circle>',
    close: '<path d="M6 6l12 12M18 6L6 18"></path>',
    swap: '<path d="M3 7h14"></path><path d="M13 3l4 4-4 4"></path><path d="M21 17H7"></path><path d="M11 21l-4-4 4-4"></path>',
    minus: '<path d="M5 12h14"></path>',
    search: '<circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path>'
  };
  function icon(name, cls) {
    return '<svg class="ic' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
  }

  /* ---------------- helpers ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function round2(n) { return Math.round((n + 1e-9) * 100) / 100; }
  function numBE(n) {
    var v = round2(n || 0);
    var parts = v.toFixed(2).split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return intPart + ',' + parts[1];
  }
  function eurPlainNL(n) { var v = (Math.round(n * 100) / 100).toFixed(2).split('.'); v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return '€ ' + v.join(','); }
  /* een heel bedrag zonder centen, bv. voor "Zet budget op € 55" */
  function eurWholeNL(n) { var s = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return '€ ' + s; }
  /* totaal in het koopblok: zelfde opbouw als priceHTML op een productscene (euroteken en ",99" klein) */
  function buyHtml(n) {
    var parts = numBE(n).split(',');
    return '<span class="cws-eur">&euro;</span>' + parts[0] + '<small>,' + parts[1] + '</small>';
  }
  function eurHtml(n) {
    var parts = numBE(n).split(',');
    return '<span class="cws-eur">&euro;</span>' + parts[0] + ',<small>' + parts[1] + '</small>';
  }
  /* budget is altijd een heel bedrag: zonder ",00" (eigenaar 5 okt) */
  function eurWholeHtml(n) {
    return '<span class="cws-eur">&euro;</span>' + numBE(Math.round(n)).split(',')[0];
  }
  function prefersReduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function cssEsc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }
  function brusselsHour() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Brussels', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var h = parts.filter(function (p) { return p.type === 'hour'; })[0];
      return h ? parseInt(h.value, 10) % 24 : new Date().getHours();
    } catch (e) { return new Date().getHours(); }
  }
  function greetingKey() {
    var h = brusselsHour();
    if (h >= 5 && h < 12) return 'morning';
    if (h >= 12 && h < 18) return 'afternoon';
    return 'evening';
  }
  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

  /* ---------------- voorkeur onthouden: budget, franchise, seed (try/catch, elk gebruik) ---------------- */
  var LS_KEY = 'cws-budget-v1';
  function loadPrefs() {
    try {
      if (!window.localStorage) return null;
      var raw = window.localStorage.getItem(LS_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      return (obj && typeof obj === 'object') ? obj : null;
    } catch (e) { return null; }
  }
  function savePrefs(budget, franchise, seed) {
    try {
      if (!window.localStorage) return;
      window.localStorage.setItem(LS_KEY, JSON.stringify({ budget: budget, franchise: franchise, seed: seed }));
    } catch (e) { /* stil negeren, geen opslag beschikbaar */ }
  }

  /* ---------------- voorkeur producttype: enkel categorieen die echte producten bevatten
     (nooit accessoires), afgeleid uit de velden type/kind van ctx.products, max 6. ---------------- */
  var TYPE_CAT_DEFS = [
    { id: 'packs', match: function (p) { return p.kind === 'Booster Pack' || p.kind === 'Double Pack Set'; } },
    { id: 'blister', match: function (p) { return p.kind === 'Blister'; } },
    { id: 'bundles', match: function (p) { return p.kind === 'Booster Bundle'; } },
    { id: 'etb', match: function (p) { return p.kind === 'Elite Trainer Box'; } },
    { id: 'boxen', match: function (p) { return p.kind === 'Booster Box'; } },
    { id: 'collecties', match: function (p) { return p.kind === 'Ultra Premium Collection' || p.kind === 'Collectie box' || p.kind === 'Tin'; } },
    { id: 'cases', match: function (p) { return p.kind !== 'Booster Bundle' && /display|case/i.test(p.kind || ''); } }
  ];
  function classifyProduct(p) {
    for (var i = 0; i < TYPE_CAT_DEFS.length; i++) { if (TYPE_CAT_DEFS[i].match(p)) return TYPE_CAT_DEFS[i].id; }
    return null;
  }
  function deriveTypeCats(products) {
    var counts = {};
    (products || []).forEach(function (p) {
      if (!p || p.av === false || p.type === 'acc') return;
      var id = classifyProduct(p);
      if (!id) return;
      counts[id] = (counts[id] || 0) + 1;
    });
    var out = [];
    TYPE_CAT_DEFS.forEach(function (def) { if (counts[def.id]) out.push({ id: def.id, count: counts[def.id] }); });
    return out.slice(0, 6);
  }
  function lowerFirst(s) { return s ? s.charAt(0).toLowerCase() + s.slice(1) : s; }
  /* kleine beginletter, behalve bij eigennamen als "Elite Trainer Boxen" (tweede woord met hoofdletter) */
  function lowerSmart(s) { return /^\S+\s+[A-Z]/.test(s || '') ? s : lowerFirst(s); }
  function joinCatLabels(ids, t, lower) {
    var labels = ids.map(function (id) { return t.prefCat[id]; }).filter(Boolean).map(function (l) { return lower ? lowerSmart(l) : l; });
    if (!labels.length) return '';
    if (labels.length === 1) return labels[0];
    return labels.slice(0, -1).join(', ') + ' ' + t.prefsJoinWord + ' ' + labels[labels.length - 1];
  }

  /* ---------------- voorkeur producttype bewaren: localStorage, try/catch, apart van het
     budget (zodat een feed-wijziging de ene voorkeur niet met de andere laat botsen) ---------------- */
  /* v2 (6 okt): { mode: 'auto' (CARDIX kiest) | 'manual' (zelf), types, style: packs|mixed|big,
     purpose: stream|seal|gift, avoid: vermijd eerder gekochte producten }. v1 had enkel mode en types:
     die worden bij het laden overgenomen, de rest krijgt de standaard. */
  var LS_PREFS_KEY = 'cws-prefs-v3', LS_PREFS_KEY_V2 = 'cws-prefs-v2', LS_PREFS_KEY_V1 = 'cws-prefs-v1';
  var STYLE_VALS = ['packs', 'mixed', 'big'], PURPOSE_VALS = ['stream', 'seal', 'gift'];
  /* eigenaar 7 okt: eerder gekochte producten nooit meer standaard weglaten (avoid uit); wie het zelf aanzet in Filters, mag */
  /* handles die de klant eerder kocht (ctx.history.bought), voor het label "Eerder gekocht" */
  function boughtSetOf(ctx) { var s = {}; ((ctx && ctx.history && ctx.history.bought) || []).forEach(function (b) { if (b && b.handle) s[b.handle] = 1; }); return s; }
  function defaultTypePrefs() { return { mode: 'auto', types: [], style: 'mixed', purpose: 'stream', avoid: false }; }
  function cleanTypePrefs(obj) {
    var d = defaultTypePrefs();
    if (!obj || typeof obj !== 'object') return d;
    d.mode = obj.mode === 'manual' ? 'manual' : 'auto';
    d.types = Array.isArray(obj.types) ? obj.types.filter(function (x) { return typeof x === 'string'; }) : [];
    if (STYLE_VALS.indexOf(obj.style) !== -1) d.style = obj.style;
    if (PURPOSE_VALS.indexOf(obj.purpose) !== -1) d.purpose = obj.purpose;
    /* v3: enkel een expliciete keuze telt; v2 en v1 hadden avoid standaard aan en worden genegeerd */
    if (obj.v === 3 && obj.avoid === true) d.avoid = true;
    return d;
  }
  function loadTypePrefs() {
    try {
      if (!window.localStorage) return null;
      var raw = window.localStorage.getItem(LS_PREFS_KEY) || window.localStorage.getItem(LS_PREFS_KEY_V2) || window.localStorage.getItem(LS_PREFS_KEY_V1);
      if (!raw) return null;
      return cleanTypePrefs(JSON.parse(raw));
    } catch (e) { return null; }
  }
  function saveTypePrefs(tp) {
    try {
      if (!window.localStorage) return;
      window.localStorage.setItem(LS_PREFS_KEY, JSON.stringify({ v: 3, mode: tp.mode, types: tp.types, style: tp.style, purpose: tp.purpose, avoid: tp.avoid === true }));
    } catch (e) { /* stil negeren, geen opslag beschikbaar */ }
  }
  /* alleen categorieen die nu echt bestaan blijven over: een feed-wijziging kan een oude
     voorkeur anders laten verwijzen naar een categorie die niet meer voorkomt */
  function resolveTypePrefs(availableCatIds) {
    var tp = loadTypePrefs() || defaultTypePrefs();
    tp.types = tp.types.filter(function (id) { return availableCatIds.indexOf(id) !== -1; });
    return tp;
  }

  /* ---------------- "laat CARDIX kiezen": weegt ctx.history (optioneel) per categorie, aankopen
     het zwaarst, dan bekeken, recentere items wegen zwaarder, een match met de huidige
     franchise ook. zonder (bruikbare) geschiedenis: lege lijst, dan geldt de bestaande
     slimme mix en het regeltje "CARDIX kiest een gevarieerde mix". ---------------- */
  function deriveHistoryTypes(ctx, franchiseKey) {
    var history = ctx.history;
    var bought = (history && history.bought) || [];
    var viewed = (history && history.viewed) || [];
    if (!bought.length && !viewed.length) return [];
    var byHandle = {};
    (ctx.products || []).forEach(function (p) { byHandle[p.handle] = p; });
    var score = {};
    function add(handle, weight, recencyBonus) {
      var p = byHandle[handle];
      if (!p || p.type === 'acc') return;
      var id = classifyProduct(p);
      if (!id) return;
      var franchiseBonus = productMatchesFranchise(p, franchiseKey) ? 1.4 : 1;
      score[id] = (score[id] || 0) + weight * franchiseBonus * recencyBonus;
    }
    bought.slice().sort(function (a, b) { return (b.at || 0) - (a.at || 0); })
      .forEach(function (b, i) { add(b.handle, 3 * Math.max(1, b.qty || 1), 1 / (1 + i * 0.25)); });
    viewed.slice().sort(function (a, b) { return (b.at || 0) - (a.at || 0); })
      .forEach(function (v, i) { add(v.handle, 1, 1 / (1 + i * 0.25)); });
    var ids = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; });
    return ids.slice(0, 2);
  }
  /* de voorkeur die echt meetelt bij het samenstellen, in volgorde van sterkte:
     1. zelf gekozen types (hard: enkel die types zodra er een past)
     2. doel Sealed bewaren / Cadeau (PURPOSE_TYPES, hard: geen losse packs)
     3. samenstelling Veel packs / Eén groot stuk (STYLE_TYPES, zacht gewicht)
     4. CARDIX-modus: de types uit ctx.history (zacht), met stijl gemengd, doel stream, vermijden aan
     style, purpose en avoid sturen verder composeBasketCore en composeFor. */
  var PURPOSE_TYPES = { seal: ['boxen', 'etb', 'collecties', 'bundles'], gift: ['etb', 'collecties'] };
  var STYLE_TYPES = { packs: ['packs', 'blister'], big: ['etb', 'boxen', 'collecties', 'bundles'] };
  function effectiveTypePrefs(ctx, state) {
    var tp = state.typePrefs || defaultTypePrefs();
    if (tp.mode === 'manual') {
      var out = { mode: 'manual', style: tp.style, purpose: tp.purpose, avoid: tp.avoid === true, types: [], source: 'none', strict: false };
      if (tp.types.length) { out.types = tp.types.slice(); out.source = 'manual'; out.strict = true; }
      else if (PURPOSE_TYPES[tp.purpose]) { out.types = PURPOSE_TYPES[tp.purpose].slice(); out.source = 'purpose'; out.strict = true; }
      else if (STYLE_TYPES[tp.style]) { out.types = STYLE_TYPES[tp.style].slice(); out.source = 'style'; }
      return out;
    }
    var hist = deriveHistoryTypes(ctx, state.franchise);
    return { mode: 'auto', style: 'mixed', purpose: 'stream', avoid: (state.typePrefs && state.typePrefs.avoid === true), types: hist, source: hist.length ? 'cardix' : 'none', strict: false };
  }
  /* kopregel van het paneel: "CARDIX kiest, vooral booster packs, om te openen" */
  function prefsLineText(t, eff) {
    var parts = [t.prefsSumWho[eff.mode === 'manual' ? 'manual' : 'cardix']];
    if (eff.source === 'manual' || eff.source === 'cardix') parts.push(t.prefsSumTypes(joinCatLabels(eff.types, t, true)));
    else if (eff.mode !== 'manual') parts.push(t.prefsSumMix);
    if (eff.style && t.prefsSumStyle[eff.style]) parts.push(t.prefsSumStyle[eff.style]);
    if (eff.purpose && t.prefsSumPurpose[eff.purpose]) parts.push(t.prefsSumPurpose[eff.purpose]);
    return parts.join(', ');
  }
  /* aantal afwijkingen van de standaard, voor het bolletje op de knop (enkel bij zelf kiezen) */
  function prefsActiveCount(tp) {
    if (!tp) return 0;
    if (tp.mode !== 'manual') return tp.avoid === true ? 1 : 0; /* in de CARDIX-stand telt enkel vermijden */
    return (tp.types.length ? 1 : 0) + (tp.style !== 'mixed' ? 1 : 0) + (tp.purpose !== 'stream' ? 1 : 0) + (tp.avoid === true ? 1 : 0);
  }
  /* producten op voorraad per categorie voor de gekozen franchise (het kleine cijfer op elke chip) */
  function typeCountsFor(products, franchiseKey) {
    var counts = {};
    (products || []).forEach(function (p) {
      if (!p || p.av === false || p.type === 'acc' || !productMatchesFranchise(p, franchiseKey)) return;
      var id = classifyProduct(p);
      if (id) counts[id] = (counts[id] || 0) + 1;
    });
    return counts;
  }
  function boughtMap(ctx) {
    var m = {}, list = (ctx.history && ctx.history.bought) || [];
    list.forEach(function (b) { if (b && b.handle) m[b.handle] = true; });
    return m;
  }

  /* ---------------- budgetslider: 25 tot 1000 (eigenaar 5 okt), elk label even ver van het volgende ----------------
     stuksgewijs lineair tussen de schaallabels: 25-50, 50-100, ... 500-1000 krijgen elk een even breed stuk van de
     baan, dus de labels staan netjes verdeeld en er blijft veel ruimte voor de kleine bedragen. Een eigen bedrag
     (10 tot 2.000) blijft mogelijk via het potlood bij het grote bedrag. */
  var SLIDER_MARKS = [25, 50, 100, 250, 500, 1000];
  var SLIDER_MIN = SLIDER_MARKS[0], SLIDER_MAX = SLIDER_MARKS[SLIDER_MARKS.length - 1];
  var SLIDER_DEBOUNCE_MS = 180;
  function posFromBudget(b) {
    var n = SLIDER_MARKS.length - 1;
    if (b <= SLIDER_MIN) return 0;
    if (b >= SLIDER_MAX) return 1;
    for (var i = 0; i < n; i++) {
      var a = SLIDER_MARKS[i], z = SLIDER_MARKS[i + 1];
      if (b <= z) return (i + (b - a) / (z - a)) / n;
    }
    return 1;
  }
  function budgetFromPos(pos) {
    var n = SLIDER_MARKS.length - 1, x = Math.max(0, Math.min(1, pos)) * n, i = Math.min(n - 1, Math.floor(x));
    var v = SLIDER_MARKS[i] + (x - i) * (SLIDER_MARKS[i + 1] - SLIDER_MARKS[i]);
    /* ronde bedragen: per euro tot 100, per 5 tot 250, daarboven per 10 */
    var step = v < 100 ? 1 : v < 250 ? 5 : 10;
    return Math.round(v / step) * step;
  }
  function isCustomBudget(b) { return SLIDER_MARKS.indexOf(b) === -1; }

  /* ---------------- franchise ---------------- */
  var FRANCHISE3_VALS = ['mix', 'pokemon', 'one_piece', ''];
  function franchiseLabel(t, key) {
    if (key === 'pokemon') return t.franchise3.pokemon;
    if (key === 'one_piece') return t.franchise3.one_piece;
    if (key === 'mix') return t.franchise3.mix;
    return t.franchise3.andere;
  }
  function productMatchesFranchise(p, key) {
    if (key === 'mix') return true; /* mix van alle franchises (eigenaar 5 okt) */
    if (key === 'pokemon') return p.franchise === 'Pokémon';
    if (key === 'one_piece') return p.franchise === 'One Piece';
    return p.franchise !== 'Pokémon' && p.franchise !== 'One Piece';
  }

  /* ---------------- seeded shuffle: enkel kandidaten met een gelijkaardige prijs (binnen 50%
     van de vorige, dezelfde orde van grootte) wisselen van volgorde, deterministisch per seed.
     mulberry32, geen afhankelijkheid. ---------------- */
  function mulberry32(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function seededShuffle(arr, seedNum) {
    var rng = mulberry32(seedNum >>> 0);
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rng() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }
  function seededPriceOrder(pool, seed) {
    var sorted = pool.slice().sort(function (a, b) { return b.price - a.price; });
    var clusters = [], cur = [];
    sorted.forEach(function (p) {
      if (!cur.length) { cur.push(p); return; }
      var prevPrice = cur[cur.length - 1].price;
      var ratio = prevPrice > 0 ? (prevPrice - p.price) / prevPrice : 0;
      if (ratio <= 0.5) cur.push(p); else { clusters.push(cur); cur = [p]; }
    });
    if (cur.length) clusters.push(cur);
    var out = [];
    clusters.forEach(function (cluster, ci) {
      var shuffled = cluster.length > 1 ? seededShuffle(cluster, ((seed * 2654435761) + ci * 97) >>> 0) : cluster;
      out = out.concat(shuffled);
    });
    return out;
  }

  /* ---------------- mandje samenstellen, deterministisch per (budget, franchise, seed) ----------------
     eerst het duurste product tot ongeveer 70% van het budget, daarna aanvullen van duur naar
     goedkoop (packs tot 6 stuks), nooit boven het budget, hoogstens 8 regels, dan een tweede
     vulronde van goedkoop naar duur om het budget zo dicht mogelijk te benaderen. */
  var ROWS_MAX = 8, PACK_QTY_MAX = 6, PREF_SHARE = 0.8;
  /* zelf bijstellen mag bij elk product, ook dozen (eigenaar 5 okt: "bij een single product kan ik geen meer toevoegen");
     het voorstel van CARDIX zelf houdt PACK_QTY_MAX en 1 per doos */
  var MANUAL_QTY_MAX = 10;
  /* prefTypes (optioneel): categorie-id's uit TYPE_CAT_DEFS die zwaarder mogen wegen, ongeveer
     tot 80% van het budget waar dat kan; de rest vult enkel aan. is er binnen budget en
     franchise niks van het gekozen type, dan valt het resultaat terug op de normale mix
     (result.prefFallback = true, zodat de UI "hier is een alternatief" kan tonen). */
  /* korte productnaam voor kaartjes: franchise-voorvoegsel, haakjes en het producttype
     eraf (dat type staat apart als klein regeltje), zodat de naam op 1 regel past */
  var KIND_SUFFIX_RE = /\s*[-:]?\s*(Sleeved Booster Pack|Booster Pack|Booster Box|Elite Trainer Box|Booster Bundle Display|Booster Bundle|Mini Tin|Tin|Ultra Premium Collection|Super Premium Collection|Collection Box|Double Pack Set|2-pack Blister|Blister|Bundle)\b.*$/i;
  function shortTitle(title) {
    var s = String(title || '').replace(/^Pok[eé]mon TCG:\s*/i, '').replace(/^Disney Lorcana Set \d+:\s*/i, 'Lorcana ')
      .replace(/^One Piece( Card Game)?:?\s*/i, '').replace(/\s*\([^)]*\)/g, '').trim();
    var s2 = s.replace(KIND_SUFFIX_RE, '').replace(/[\s\-:&]+$/, '').trim();
    return s2 || s;
  }
  var KIND_LABELS = {
    nl: { 'Collectie box': 'Collectiebox', 'Double Pack Set': 'Double Pack Set' },
    fr: { 'Collectie box': 'Coffret collection', 'Tin': 'Tin', 'Blister': 'Blister' },
    en: { 'Collectie box': 'Collection box' }
  };
  function kindLabel(ctx, handle) {
    var p = null, list = ctx.products || [];
    for (var i = 0; i < list.length; i++) { if (list[i] && list[i].handle === handle) { p = list[i]; break; } }
    var k = p && p.kind ? p.kind : '';
    if (!k) return '';
    var map = KIND_LABELS[ctx.lang] || KIND_LABELS.nl;
    return map[k] || k;
  }

  /* eigen categoriekeuze (strict) is hard: zodra er binnen budget en franchise minstens 1
     product van die categorie past, komen er ENKEL producten van die categorie in (eigenaar
     5 okt: "ik klik ETB's maar toch geeft die andere suggesties"). Past er geen enkel, dan
     de bestaande terugval met uitleg. CARDIX-keuze (niet strict) blijft een zachte weging. */
  function composeBasket(products, budget, franchiseKey, seed, prefTypes, strict, opts) {
    if (strict && prefTypes && prefTypes.length) {
      var strictPool = (products || []).filter(function (p) {
        var id = p && classifyProduct(p);
        return p && p.av !== false && p.type !== 'acc' && productMatchesFranchise(p, franchiseKey) && id && prefTypes.indexOf(id) !== -1;
      });
      var anyFits = strictPool.some(function (p) { return p.price <= budget + 1e-9; });
      if (anyFits) {
        var r = composeBasketCore(strictPool, budget, 'mix', seed, null, opts);
        r.prefFallback = false;
        return r;
      }
    }
    return composeBasketCore(products, budget, franchiseKey, seed, prefTypes, opts);
  }
  /* composeFor: de ene plek waar alle voorkeuren samenkomen (eigen types/doel/stijl via effectiveTypePrefs,
     "vermijd wat ik al kocht" via ctx.history.bought). st heeft budget, franchise en typePrefs. Blijft er na het
     vermijden niets over, dan valt het terug op de volledige lijst zodat het scherm nooit leeg wordt door deze optie. */
  function composeFor(ctx, st, products, seed) {
    var eff = effectiveTypePrefs(ctx, st);
    var opts = { style: eff.style };
    var src = products || [];
    var res = null;
    if (eff.avoid) {
      var bought = boughtMap(ctx);
      var kept = src.filter(function (p) { return !(p && bought[p.handle]); });
      if (kept.length && kept.length !== src.length) {
        res = composeBasket(kept, st.budget, st.franchise, seed, eff.types, eff.strict, opts);
        if (!res.items.length) res = null;
      }
    }
    if (!res) res = composeBasket(src, st.budget, st.franchise, seed, eff.types, eff.strict, opts);
    res.eff = eff;
    return res;
  }
  /* opts.style stuurt de samenstelling: 'packs' = pool beperkt tot kleine producten (tot 20% van het budget) met een
     hoofdproduct van ten hoogste 25% van het budget, dus veel regels en aantallen; 'big' = het hoofdproduct mag het
     hele budget vullen en er zijn hoogstens 2 regels; 'mixed' = het gedrag van altijd (70%, 8 regels). */
  function composeBasketCore(products, budget, franchiseKey, seed, prefTypes, opts) {
    var style = (opts && opts.style) || 'mixed';
    var rowsMax = style === 'big' ? 2 : ROWS_MAX;
    var anchorShare = style === 'big' ? 1 : (style === 'packs' ? 0.25 : 0.7);
    var pool = (products || []).filter(function (p) {
      return p && p.av !== false && p.type !== 'acc' && productMatchesFranchise(p, franchiseKey);
    });
    if (!pool.length) return { items: [], total: 0 };
    if (style === 'packs') {
      var smallPool = pool.filter(function (p) { return p.price <= Math.max(budget * 0.2, 1) + 1e-9; });
      if (smallPool.length >= 2) pool = smallPool;
    }
    var hasPref = !!(prefTypes && prefTypes.length);
    var isPreferred = function (p) { var id = classifyProduct(p); return !!(id && prefTypes.indexOf(id) !== -1); };
    var preferredPool = hasPref ? pool.filter(isPreferred) : [];
    var usedFallback = hasPref && preferredPool.length === 0;

    var byPriceDesc = seededPriceOrder(pool, seed || 0);
    var byPriceDescPref = hasPref && preferredPool.length ? seededPriceOrder(preferredPool, seed || 0) : [];

    var anchor = null, anchorFromPref = false;
    for (var ip = 0; ip < byPriceDescPref.length; ip++) {
      if (byPriceDescPref[ip].price <= budget * anchorShare + 1e-9) { anchor = byPriceDescPref[ip]; anchorFromPref = true; break; }
    }
    /* past er van het gekozen type niets onder 70%, dan mag het hoofdproduct van dat type
       tot het volledige budget gaan (een ETB van 99,99 bij 135 euro moet erin) */
    if (!anchor) {
      var prefFit = byPriceDescPref.filter(function (p) { return p.price <= budget + 1e-9; });
      if (prefFit.length) { anchor = prefFit[0]; anchorFromPref = true; }
    }
    if (!anchor) {
      for (var i = 0; i < byPriceDesc.length; i++) {
        if (byPriceDesc[i].price <= budget * anchorShare + 1e-9) { anchor = byPriceDesc[i]; break; }
      }
    }
    if (!anchor) {
      var fits = byPriceDesc.filter(function (p) { return p.price <= budget + 1e-9; }).sort(function (a, b) { return a.price - b.price; });
      anchor = fits[0] || null;
    }
    if (!anchor) {
      var cheap = pool.slice().sort(function (a, b) { return a.price - b.price; })[0];
      return { items: [], total: 0, cheapest: cheap ? cheap.price : null };
    }
    if (hasPref && !anchorFromPref && preferredPool.length) usedFallback = true;

    var items = [{ handle: anchor.handle, title: anchor.title, price: anchor.price, type: anchor.type, qty: 1 }];
    var used = {}; used[anchor.handle] = 1;
    var remaining = round2(budget - anchor.price);
    var preferredSpent = anchorFromPref ? anchor.price : 0;
    var preferredCap = budget * PREF_SHARE;
    var rest = byPriceDesc.filter(function (p) { return p.handle !== anchor.handle; });
    var restPref = byPriceDescPref.filter(function (p) { return p.handle !== anchor.handle; });
    var boost = false;
    function maxQtyFor(p) { return boost ? MANUAL_QTY_MAX : (p.type === 'pack' ? PACK_QTY_MAX : 1); }
    function rowFor(handle) {
      for (var k = 0; k < items.length; k++) { if (items[k].handle === handle) return items[k]; }
      return null;
    }
    function tryAdd(p, fromPref) {
      var already = used[p.handle] || 0;
      if (already >= maxQtyFor(p)) return false;
      if (p.price > remaining + 1e-9) return false;
      if (!already && items.length >= rowsMax) return false;
      used[p.handle] = already + 1;
      remaining = round2(remaining - p.price);
      if (fromPref) preferredSpent = round2(preferredSpent + p.price);
      var row = rowFor(p.handle);
      if (row) row.qty++; else items.push({ handle: p.handle, title: p.title, price: p.price, type: p.type, qty: 1 });
      return true;
    }

    var guard = 0;
    while (items.length < rowsMax && guard < 500) {
      guard++;
      var added = false;
      /* zolang het aandeel van het gekozen type onder de kaap blijft (ongeveer 80% van het
         budget) en er nog kandidaten van dat type zijn, vult die rij eerst aan; pas daarna
         (of zonder voorkeur) de rest, net als voorheen van duur naar goedkoop. */
      if (hasPref && preferredSpent < preferredCap - 1e-9) {
        for (var jp = 0; jp < restPref.length; jp++) { if (tryAdd(restPref[jp], true)) { added = true; break; } }
        if (added) continue;
      }
      for (var j = 0; j < rest.length; j++) { if (tryAdd(rest[j], false)) { added = true; break; } }
      if (!added) break;
    }
    var byPriceAsc = rest.slice().sort(function (a, b) { return a.price - b.price; });
    guard = 0;
    while (guard < 500) {
      guard++;
      var addedTop = false;
      for (var m = 0; m < byPriceAsc.length; m++) { if (tryAdd(byPriceAsc[m], false)) { addedTop = true; break; } }
      if (!addedTop) break;
    }
    /* groot budget (eigen bedrag tot 2000, eigenaar 5 okt: "selecteert maar tot 1000"): met 1 per doos, 6 per pack en
       8 regels zat het mandje vol voor het budget op was. Blijft er meer dan 5% over, dan mag elk product verder oplopen
       tot MANUAL_QTY_MAX, beurtelings van duur naar goedkoop (1 extra per product per ronde), zodat het gespreid blijft. */
    if (remaining > budget * 0.05) {
      boost = true;
      guard = 0;
      while (guard < 200) {
        guard++;
        var addedRound = false;
        for (var q = 0; q < byPriceDesc.length; q++) { if (tryAdd(byPriceDesc[q], false)) addedRound = true; }
        if (!addedRound) break;
      }
    }

    var total = 0;
    items.forEach(function (it) { total = round2(total + it.price * it.qty); });
    var result = { items: items, total: total };
    if (hasPref) result.prefFallback = usedFallback;
    return result;
  }
  function basketSignature(items) {
    return items.map(function (it) { return it.handle + ':' + it.qty; }).sort().join('|');
  }
  function handleSet(items) {
    var s = {}; items.forEach(function (it) { s[it.handle] = true; }); return s;
  }
  function sameHandleSet(itemsA, itemsB) {
    var a = handleSet(itemsA), b = handleSet(itemsB);
    var ak = Object.keys(a), bk = Object.keys(b);
    if (ak.length !== bk.length) return false;
    for (var i = 0; i < ak.length; i++) { if (!b[ak[i]]) return false; }
    return true;
  }
  /* het laagste bedrag (naar boven afgerond op een hele euro) waarmee deze franchise iets
     oplevert: gebruikt voor "Zet budget op" in de lege stand */
  function cheapestInFranchise(products, franchiseKey) {
    var pool = (products || []).filter(function (p) {
      return p && p.av !== false && p.type !== 'acc' && productMatchesFranchise(p, franchiseKey);
    });
    if (!pool.length) return null;
    var min = pool.reduce(function (m, p) { return p.price < m ? p.price : m; }, Infinity);
    return Math.ceil(min);
  }
  function findProduct(ctx, handle) {
    var list = (ctx && ctx.products) || [];
    for (var i = 0; i < list.length; i++) { if (list[i] && list[i].handle === handle) return list[i]; }
    return null;
  }

  /* ---------------- zelf aanpassen: verwijderen, vervangen, toevoegen (eigenaar 5 okt) ----------------
     zodra de klant iets handmatig aanpast is de selectie "eigen" (state.isManual): een wissel
     van budget of franchise overschrijft die niet meer stilzwijgend (currentBasket geeft dan
     gewoon state.manualItems terug). enkel "Andere selectie" of "Herstel voorstel" wissen de
     eigen-status weer. nooit in localStorage, enkel in de staat van de pagina. */
  function cloneManualItems(items) {
    return (items || []).map(function (it) {
      return { handle: it.handle, title: it.title, price: it.price, type: it.type, qty: it.qty, _slotKey: it._slotKey || it.handle };
    });
  }
  function manualTotal(items) {
    var total = 0;
    (items || []).forEach(function (it) { total = round2(total + it.price * it.qty); });
    return total;
  }
  function ensureManual(state) {
    if (!state.isManual) { state.manualItems = cloneManualItems(state.lastItems); state.isManual = true; }
  }
  /* kruisje = het hele product weg, ook bij een aantal hoger dan 1 (eigenaar 5 okt); minder doe je met de min-knop */
  function removeFromManual(state, handle) {
    ensureManual(state);
    var items = state.manualItems;
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) { items.splice(i, 1); break; }
    }
  }
  function setQtyInManual(state, handle, qty) {
    ensureManual(state);
    var items = state.manualItems;
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) {
        if (qty <= 0) items.splice(i, 1); else items[i].qty = qty;
        break;
      }
    }
  }
  /* vervangen: dichtstbijzijnde prijs, zelfde categorie (classifyProduct) en franchise, past
     in het resterende budget plus de prijs van de hele oude regel. elke volgende klik op
     dezelfde plek sluit de al getoonde alternatieven uit (cyclisch, begint opnieuw als alles
     al geweest is). geeft true bij een echt alternatief, anders false ("geen alternatief"). */
  function replaceInManual(ctx, state, handle) {
    ensureManual(state);
    var items = state.manualItems;
    var idx = -1;
    for (var i = 0; i < items.length; i++) { if (items[i].handle === handle) { idx = i; break; } }
    if (idx === -1) return false;
    var oldItem = items[idx];
    var oldProduct = findProduct(ctx, handle);
    var cat = oldProduct ? classifyProduct(oldProduct) : null;
    if (!cat) return false;
    var usedHandles = {};
    items.forEach(function (it, i2) { if (i2 !== idx) usedHandles[it.handle] = true; });
    var otherTotal = round2(manualTotal(items) - oldItem.price * oldItem.qty);
    var budgetRoom = round2(state.budget - otherTotal);
    /* hoogste stukprijs voor de vervanger (eigenaar 5 okt: "geen alternatief, er staan genoeg producten met dezelfde of
       mindere waarde"): wat in het budget past (rekening houdend met het aantal), maar nooit minder dan de huidige prijs.
       Stond de selectie al boven het budget, dan was budgetRoom negatief en vond het nooit iets. */
    var unitLimit = Math.max(oldItem.price, budgetRoom / Math.max(1, oldItem.qty));
    var slotKey = oldItem._slotKey || handle;
    state.replaceSeen = state.replaceSeen || {};
    var seen = state.replaceSeen[slotKey] || [handle];
    function pool(excludeSeen, sameCat) {
      return (ctx.products || []).filter(function (p) {
        return p && p.av !== false && p.type !== 'acc' && !usedHandles[p.handle] && p.handle !== handle
          && (!excludeSeen || seen.indexOf(p.handle) === -1)
          && productMatchesFranchise(p, state.franchise) && (!sameCat || classifyProduct(p) === cat)
          && p.price <= unitLimit + 1e-9;
      }).sort(function (a, b) { return Math.abs(a.price - oldItem.price) - Math.abs(b.price - oldItem.price); });
    }
    /* eerst hetzelfde type; staat elk product van dat type al in de selectie (bv. alle 4 de ETB's, eigenaar 5 okt:
       "er zijn producten genoeg"), dan een ander type uit dezelfde franchise, zo dicht mogelijk bij de huidige prijs */
    var candidates = pool(true, true);
    if (!candidates.length && seen.length > 1) { seen = [handle]; candidates = pool(true, true); }
    if (!candidates.length) candidates = pool(true, false);
    if (!candidates.length && seen.length > 1) { seen = [handle]; candidates = pool(true, false); }
    if (!candidates.length) return false;
    var pick = candidates[0];
    seen.push(pick.handle);
    state.replaceSeen[slotKey] = seen;
    items[idx] = { handle: pick.handle, title: pick.title, price: pick.price, type: pick.type, qty: oldItem.qty, _slotKey: slotKey };
    return true;
  }
  function addToManual(ctx, state, handle) {
    ensureManual(state);
    var p = findProduct(ctx, handle);
    if (!p) return;
    var items = state.manualItems;
    var row = null;
    for (var i = 0; i < items.length; i++) { if (items[i].handle === handle) { row = items[i]; break; } }
    if (row) {
      if (row.qty < MANUAL_QTY_MAX) row.qty++;
    } else {
      items.push({ handle: p.handle, title: p.title, price: p.price, type: p.type, qty: 1, _slotKey: p.handle });
    }
  }
  function restoreSuggestion(el, ctx, state) {
    state.isManual = false; state.manualItems = null; state.replaceSeen = {};
    resetAddButton(el, ctx, state);
    clearRefreshMsg(el);
    updateBasket(el, ctx, state, false);
  }

  /* ---------------- carrousel van losse producten, elk een eigen 3D-object -----------------
     vaste maat (ongeveer 200 x 220 beeld), nooit overlap, nooit clustering: bij te veel
     producten om in 1 oogopslag te tonen scrollt de rij (scroll-snap) in plaats van te
     krimpen. */
  /* de producten zijn de held van dit scherm: de afbeelding krimpt nooit onder 220 px (desktop)
     of 150 px (mobiel), ook niet als het koopblok daardoor minder ruimte overlaat (eigenaar 5
     okt) -- floor == cap, dus computeItemImgH geeft altijd exact deze vaste hoogte. */
  /* labelreserve +56 / +44 (6 okt): elk product staat nu in een eigen kaart (padding, rand, schaduwruimte), anders werd de onderkant afgekapt */
  var ITEM_W = 200, ITEM_IMG_H = 320, ITEM_IMG_H_MOBILE = 150, ITEM_LABEL_H = 122, ITEM_LABEL_H_MOBILE = 122, ITEM_GAP = 16, ITEM_MIN_H = 90, ITEM_MIN_H_MOBILE = 90;
  function computeItemImgH(boxH, isNarrow) {
    var cap = isNarrow ? ITEM_IMG_H_MOBILE : ITEM_IMG_H;
    var labelReserve = isNarrow ? ITEM_LABEL_H_MOBILE : ITEM_LABEL_H;
    var floor = isNarrow ? ITEM_MIN_H_MOBILE : ITEM_MIN_H;
    return Math.max(floor, Math.min(cap, boxH - labelReserve));
  }
  /* brede producten (bundel, UPC, booster box) krijgen een breder vak, tot 1,3 x ITEM_W: in een vast vak van
     200 px bleven ze door de breedte klein naast een hoog pack (eigenaar 5 okt: "die bundle is super klein").
     De verhouding komt uit ctx.ar (cut-meta); zonder ctx.ar blijft elk vak ITEM_W breed. */
  var ITEM_W_MAX = 1.3, ITEM_FIT_GAP = 28;
  function itemAr(ctx, handle) { var a = ctx.ar ? +ctx.ar(handle) : 0; return a > 0 ? a : 0; }
  function itemW(ctx, handle) { var a = itemAr(ctx, handle); return a > 1.05 ? Math.round(ITEM_W * Math.min(ITEM_W_MAX, a)) : ITEM_W; }
  /* zelfde oppervlakteregel als het 3D-model (mountHero3D in app.js): packs de helft van het vak, dozen 72% */
  function itemFitArea(ctx, handle) {
    var list = ctx.products || [], k = '';
    for (var i = 0; i < list.length; i++) { if (list[i] && list[i].handle === handle) { k = list[i].kind || ''; break; } }
    return /Booster Pack|Blister|Double Pack/i.test(k) ? .5 : .72;
  }
  function fitRect(W, H, ar, area) {
    var h = Math.min(Math.sqrt(area * W * H / ar), (W * .9) / ar, H * .96);
    return { w: Math.round(h * ar), h: Math.round(h) };
  }
  /* carrousel met vakken van verschillende breedte: posities uit de echte items i.p.v. index x vaste stap */
  function stackNodes(track) {
    return (track.__cwsKeys || []).map(function (k) { return track.querySelector('[data-key="' + cssEsc(k) + '"]:not(.cws-leaving)'); }).filter(Boolean);
  }
  function stackLeft(track, idx) {
    var ns = stackNodes(track); if (!ns.length) return 0;
    return ns[Math.max(0, Math.min(ns.length - 1, idx))].offsetLeft - ns[0].offsetLeft;
  }
  function stackIdxAt(track) {
    var ns = stackNodes(track); if (!ns.length) return 0;
    var o = ns[0].offsetLeft, x = track.scrollLeft, best = 0, bd = Infinity;
    ns.forEach(function (n, i) { var d = Math.abs(n.offsetLeft - o - x); if (d < bd) { bd = d; best = i; } });
    return best;
  }

  /* ---------------- getallen vloeiend laten tellen (tabular-nums, geen breedtesprong) ---------------- */
  function animateNumber(fromVal, toVal, duration, onFrame, reduced) {
    if (reduced || Math.abs(toVal - fromVal) < 0.005) { onFrame(toVal); return; }
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - p, 3);
      onFrame(fromVal + (toVal - fromVal) * eased);
      if (p < 1) requestAnimationFrame(step);
      else onFrame(toVal);
    }
    requestAnimationFrame(step);
  }

  /* ---------------- voorkeuren oplossen: localStorage wint van ctx.compose ---------------- */
  function resolvePrefs(ctx) {
    var compose = ctx.compose || {};
    var stored = loadPrefs();
    var budget = SLIDER_MIN, franchise = 'pokemon', seed = 0;
    if (compose.budget != null) budget = compose.budget;
    if (FRANCHISE3_VALS.indexOf(compose.franchise) >= 0) franchise = compose.franchise;
    else franchise = 'pokemon';
    if (compose.budget == null) budget = 100;
    /* eigenaar 6 okt: altijd beginnen bij Alles en 75 euro; een bewaarde keuze telt niet meer bij het laden */
    budget = 75; franchise = 'mix';
    if (stored && typeof stored.seed === 'number') seed = stored.seed;
    budget = Math.max(10, Math.min(2000, budget));
    return { budget: budget, franchise: franchise, seed: seed };
  }

  /* ---------------- voorkeurenpaneel v2: kop met samenvatting, dan secties met een klein label en een fijne lijn,
     voet met "Herstel standaard" en "Klaar". Alle knoppen dragen data-attributen, de bedrading zit in wirePrefs. ---------------- */
  function prefsPanelHtml(t, typeCats, eff, counts) {
    var o = '';
    function sec(extraCls, key, label, inner) {
      return '<div class="cws-pp-sec' + extraCls + '"' + (key ? ' data-cws-pp-sec="' + key + '"' : '') + '><p class="cws-pp-lbl">' + esc(label) + '</p>' + inner + '</div>';
    }
    function radios(attr, labelMap, vals, aria) {
      var h = '<div class="cws-pp-chips" role="radiogroup" aria-label="' + esc(aria) + '">';
      vals.forEach(function (v) {
        h += '<button type="button" class="cws-pp-chip" role="radio" aria-checked="false" data-' + attr + '="' + v + '">' + esc(labelMap[v]) + '</button>';
      });
      return h + '</div>';
    }
    o += '<div class="cws-prefs-panel cws-pp" data-cws-prefs-panel role="dialog" aria-modal="true" aria-labelledby="cws-prefs-title" hidden>';
    o += '<div class="cws-pp-head"><div class="cws-pp-headtxt"><h3 class="cws-pp-title" id="cws-prefs-title">' + esc(t.prefsBtn) + '</h3>' +
      '<p class="cws-pp-sum" data-cws-prefs-sum aria-live="polite">' + esc(prefsLineText(t, eff)) + '</p></div>' +
      '<button type="button" class="cws-pp-x" data-cws-prefs-done aria-label="' + esc(t.prefsCloseAria) + '">' + icon('close') + '</button></div>';
    o += '<div class="cws-pp-body">';
    /* 1. wie kiest */
    o += sec('', '', t.prefsSecWho,
      '<div class="cws-pp-who" role="radiogroup" aria-label="' + esc(t.prefsSecWho) + '">' +
      '<button type="button" class="cws-pp-opt" role="radio" aria-checked="false" data-cws-pp-who="auto"><span>' + esc(t.prefsAuto) + '</span><span class="cws-pp-opt-sub">' + esc(t.prefsAutoSub) + '</span></button>' +
      '<button type="button" class="cws-pp-opt" role="radio" aria-checked="false" data-cws-pp-who="manual"><span>' + esc(t.prefsWhoSelf) + '</span><span class="cws-pp-opt-sub">' + esc(t.prefsWhoSelfSub) + '</span></button>' +
      '</div>');
    /* 2. types (meerdere) met aantal op voorraad */
    var chips = '<div class="cws-pp-chips" data-cws-prefs-chips>';
    chips += '<button type="button" class="cws-pp-chip" aria-pressed="false" data-cws-pp-all>' + esc(t.prefsAll) + '</button>';
    typeCats.forEach(function (c) {
      chips += '<button type="button" class="cws-pp-chip" aria-pressed="false" data-cws-prefs-chip data-type-id="' + esc(c.id) + '"><span>' + esc(t.prefCat[c.id] || c.id) + '</span><span class="cws-pp-chip-n" data-cws-chip-n>' + (counts[c.id] || 0) + '</span></button>';
    });
    chips += '</div>';
    o += sec(' cws-pp-dim', 'types', t.prefsSecTypes, chips);
    /* 3. hoe samenstellen, 4. waarvoor */
    o += sec(' cws-pp-dim', 'style', t.prefsSecStyle, radios('cws-pp-style', t.prefsStyle, STYLE_VALS, t.prefsSecStyle));
    o += sec(' cws-pp-dim', 'purpose', t.prefsSecPurpose, radios('cws-pp-purpose', t.prefsPurpose, PURPOSE_VALS, t.prefsSecPurpose));
    /* 5. slim */
    /* eigenaar 7 okt: "vermijd" ook bruikbaar in de CARDIX-stand, dus niet gedimd */
    o += sec('', 'smart', t.prefsSecSmart,
      '<button type="button" class="cws-pp-check" role="checkbox" aria-checked="false" data-cws-pp-avoid><span class="cws-pp-box">' + icon('check') + '</span><span>' + esc(t.prefsAvoid) + '</span></button>');
    o += '</div>';
    o += '<div class="cws-pp-foot"><button type="button" class="cws-pp-reset" data-cws-pp-reset>' + esc(t.prefsReset) + '</button>' +
      '<button type="button" class="cws-pp-done" data-cws-prefs-done>' + esc(t.prefsDone) + '</button></div>';
    o += '</div>';
    return o;
  }

  /* ---------------- html(ctx) ---------------- */
  function html(ctx) {
    var t = strFor(ctx.lang);
    var prefs = resolvePrefs(ctx);
    var budget = prefs.budget, franchise = prefs.franchise, seed = prefs.seed;
    var hasProducts = !!(ctx.products && ctx.products.length);

    var out = '';
    out += '<section class="cws" data-lang="' + esc(ctx.lang || 'nl') + '">';
    /* rustig, traag drijvend patroon van zeer lichte ruitjes, puur CSS (geen blur): vervangt
       de grote achtergrondnaam (eigenaar 5 okt) */
    /* geen eigen ruitjespatroon meer (eigenaar 5 okt: "exact gelijk aan het 2de scherm"): de pagina-achtergrond van de
       feed (#amb: raster, productlicht, zwevende kaartjes) schijnt door, net als achter elk productscherm */
    out += '<div class="cws-in">';

    out += '<p class="cws-greeting cws-a cws-a-fade" style="--d:0ms"><span>' + esc(t[greetingKey()]) + ', ' + esc(ctx.name || '') + '</span></p>';

    if (!hasProducts) {
      out += '<div class="cws-empty cws-a cws-a-fade" style="--d:40ms">' + esc(t.emptyTitle) + '</div>';
      out += '</div></section>';
      return out;
    }

    var typeCats = deriveTypeCats(ctx.products);
    var typeCatIds = typeCats.map(function (c) { return c.id; });
    var typePrefs = resolveTypePrefs(typeCatIds);
    var eff = effectiveTypePrefs(ctx, { typePrefs: typePrefs, franchise: franchise });
    var basket = composeFor(ctx, { budget: budget, franchise: franchise, typePrefs: typePrefs }, ctx.products, seed);
    var franchiseIdx = Math.max(0, FRANCHISE3_VALS.indexOf(franchise));
    var rawPos = Math.round(posFromBudget(budget) * 1000);

    var d = 30;
    var dTop = d; d += 60;
    var dSlider = d; d += 70;
    var dMid = d; d += 90;
    var dBuy = d; d += 70;
    var dScroll = d + 40;

    /* 1. budget + franchise: het grote bedrag is zelf bewerkbaar (potlood), geen los chipje meer */
    /* bovenkaart (6 okt): budget, franchise, CARDIX-regel en slider samen in een witte kaart; op gsm display:contents */
    out += '<div class="cws-topcard">';
    out += '<div class="cws-budget-top cws-a cws-a-fade" style="--d:' + dTop + 'ms">';
    out += '<div class="cws-budget-label">';
    /* op lagere schermen staat de begroeting klein in dit label i.p.v. op een eigen rij (zie start-scene.css) */
    out += '<span class="cws-budget-eyebrow"><span class="cws-eyebrow-greet">' + esc(t[greetingKey()]) + (ctx.name ? ', ' + esc(ctx.name) : '') + ' &middot; </span>' + esc(t.budgetLabel) + '</span>';
    out += '<div class="cws-budget-editwrap" data-cws-budget-editwrap>';
    out += '<button type="button" class="cws-budget-val" data-cws-val data-cws-val-btn aria-label="' + esc(t.budgetEditAria) + '">' + eurWholeHtml(budget) + icon('pencil', 'cws-budget-pencil') + '</button>';
    out += '<span class="cws-custom-wrap" data-cws-custom-wrap hidden>';
    out += '<span class="cws-eur">&euro;</span>';
    out += '<input type="text" inputmode="decimal" pattern="[0-9]*" class="cws-custom-input" data-cws-custom-input value="' + budget + '" aria-label="' + esc(t.customAria) + '">';
    out += '<button type="button" class="cws-custom-confirm" data-cws-custom-confirm aria-label="' + esc(t.customConfirmAria) + '">' + icon('check') + '</button>';
    out += '</span>';
    out += '</div>';
    out += '<span class="cws-custom-hint" data-cws-custom-hint hidden>' + esc(t.customHint) + '</span>';
    out += '</div>';
    out += '<div class="cws-franchise-row">';
    out += '<div class="cws-seg cws-seg-franchise3" data-group="franchise3" style="--n:' + FRANCHISE3_VALS.length + '">';
    out += '<i class="cws-seg-mark" style="--i:' + franchiseIdx + '"></i>';
    FRANCHISE3_VALS.forEach(function (f) {
      out += '<button type="button" class="' + (f === franchise ? 'cws-on' : '') + '" data-franchise3="' + esc(f) + '">' + esc(franchiseLabel(t, f)) + '</button>';
    });
    out += '</div>';
    out += '<button type="button" class="cws-prefs-btn" data-cws-prefs-btn aria-haspopup="dialog" aria-expanded="false" aria-label="' + esc(t.prefsAria) + '">' + icon('sliders', 'cws-prefs-ic');
    if (prefsActiveCount(typePrefs)) out += '<span class="cws-prefs-badge" data-cws-prefs-badge>' + prefsActiveCount(typePrefs) + '</span>';
    out += '</button>';
    /* paneel vlak bij de knop (popover-anchoring zonder JS-meting): als kind van deze rij
       geeft position:absolute meteen de juiste plek, op desktop en op mobiel (bottom sheet
       via de container-query in de CSS). */
    out += prefsPanelHtml(t, typeCats, eff, typeCountsFor(ctx.products, franchise));
    out += '</div>';
    out += '</div>';

    out += '<button type="button" class="cws-prefs-line cws-a cws-a-fade" data-cws-prefs-line style="--d:' + (dTop + 20) + 'ms">' + esc(prefsLineText(t, eff)) + '</button>';

    /* 2. slider met gelijk verdeelde schaallabels, van 25 tot 1.000 (geen "Eigen"-stap meer: dat doet het potlood) */
    out += '<div class="cws-slider-wrap cws-a cws-a-fade" style="--d:' + dSlider + 'ms">';
    out += '<div class="cws-range-track">';
    out += '<div class="cws-range-fill" data-cws-fill style="width:' + (rawPos / 10) + '%"></div>';
    out += '<input type="range" class="cws-range" min="0" max="1000" step="5" value="' + rawPos + '" data-cws-slider aria-label="' + esc(t.budgetAria) + '">';
    out += '</div>';
    out += '<div class="cws-scale">';
    SLIDER_MARKS.forEach(function (v) {
      out += '<span style="left:' + (posFromBudget(v) * 100) + '%">&euro;' + numBE(v).split(',')[0] + '</span>';
    });
    out += '</div>';
    out += '</div>';
    out += '</div>';

    /* 3. carrousel van losse producten (of de lege stand, op dezelfde vaste hoogte) */
    out += '<div class="cws-mid cws-a cws-a-fade" style="--d:' + dMid + 'ms">';
    out += '<div class="cws-pref-fallback-line" data-cws-pref-fallback hidden></div>';
    out += '<div class="cws-stackbox" data-cws-stackbox>';
    out += '<button type="button" class="cws-car-arrow cws-car-prev" data-cws-car-prev aria-label="' + esc(t.carPrev) + '" hidden>' + icon('chevl') + '</button>';
    out += '<div class="cws-carousel-track" data-cws-stack tabindex="-1">';
    out += '<div class="cws-car-empty" data-cws-car-empty hidden>';
    out += icon('box', 'cws-car-empty-icon');
    out += '<div class="cws-car-empty-title" data-cws-car-empty-title></div>';
    out += '<div class="cws-car-empty-text" data-cws-car-empty-text></div>';
    out += '<button type="button" class="cws-car-empty-peek" data-cws-empty-peek hidden></button>';
    out += '<div class="cws-car-empty-acts">';
    out += '<button type="button" class="cws-door-btn cws-door-btn-primary" data-cws-set-min></button>';
    out += '<button type="button" class="cws-door-btn cws-door-btn-ghost" data-cws-set-mix>' + esc(t.carShowMix) + '</button>';
    out += '</div>';
    out += '</div>';
    /* "Zelf toevoegen": een laatste tegel, zelfde grootte als een product, valt buiten de
       teller "1 / n" (eigenaar 5 okt). blijft als laatste kind staan (zie renderStack). */
    out += '<button type="button" class="cws-stack-item cws-add-tile" data-cws-add-tile aria-haspopup="dialog" aria-expanded="false" aria-label="' + esc(t.addChipAria) + '" hidden>' + icon('plus') + '<span>' + esc(t.addChip) + '</span></button>';
    out += '</div>';
    /* bevestiging na "Zet in mandje" (eigenaar 6 okt): broer-element van de carrousel-baan
       (niet erin: die heeft overflow/scroll, dit moet daar los van liggen), zelfde hoogte als
       de carrousel (position:absolute, inset:0 in start-scene.css, .cws-stackbox is al
       position:relative). Getoond/verborgen via de klasse cws-confirmed op .cws-stackbox
       (showConfirmCard/hideConfirmCard), niet via het hidden-attribuut. */
    out += '<div class="cws-car-confirm" data-cws-car-confirm>';
    out += icon('check', 'cws-car-confirm-icon');
    out += '<div class="cws-car-confirm-title" data-cws-confirm-title></div>';
    out += '<div class="cws-car-confirm-line" data-cws-confirm-line></div>';
    out += '<div class="cws-car-confirm-thumbs" data-cws-confirm-thumbs aria-hidden="true"></div>';
    out += '<div class="cws-car-confirm-acts">';
    out += '<button type="button" class="cws-door-btn cws-door-btn-primary" data-cws-confirm-new></button>';
    out += '<button type="button" class="cws-door-btn cws-door-btn-ghost" data-cws-confirm-cart></button>';
    out += '</div>';
    out += '<button type="button" class="cws-car-confirm-undo" data-cws-confirm-undo></button>';
    out += '</div>';
    out += '<button type="button" class="cws-car-arrow cws-car-next" data-cws-car-next aria-label="' + esc(t.carNext) + '" hidden>' + icon('chevr') + '</button>';
    out += '<span class="cws-car-counter" data-cws-car-counter aria-live="polite" hidden></span>';
    out += '</div>';
    out += '</div>';

    /* 4. koopblok: 1 compacte rij. links aantal + totaal (plus de kleine regeltjes eigen-
       selectie/boven-budget), rechts Voeg toe, Andere selectie, Zet in mandje. geen chiprij
       meer (dat herhaalde de carrousel): verwijderen, vervangen en aantal zitten nu volledig
       op de carrousel-items (eigenaar 5 okt). */
    out += '<div class="cws-buy cws-a cws-a-fade" style="--d:' + dBuy + 'ms">';
    out += '<div class="cws-buy-main">';
    /* links de totaalprijs (zelfde maat en vorm als de prijs op een productscene), daarnaast miniaturen van de
       gekozen producten + aantal, zodat de rij gevuld is i.p.v. een los "5 PRODUCTEN" erboven (eigenaar 5 okt) */
    out += '<div class="cws-buy-left">';
    out += '<div class="cws-buy-price" data-cws-total></div>';
    out += '<div class="cws-buy-info">';
    out += '<div class="cws-buy-sum"><span class="cws-buy-thumbs" data-cws-buy-thumbs aria-hidden="true"></span><span class="cws-buy-count" data-cws-buy-count></span></div>';
    out += '<span class="cws-buy-empty-line" data-cws-buy-empty-line hidden></span>';
    out += '<span class="cws-over-budget-line" data-cws-over-budget hidden></span>';
    out += '<div class="cws-manual-banner" data-cws-manual-banner hidden>';
    out += '<span data-cws-manual-text></span>';
    out += '<button type="button" class="cws-manual-restore" data-cws-manual-restore></button>';
    out += '</div>';
    out += '</div>';
    out += '</div>';
    out += '<div class="cws-buy-acts">';
    out += '<button type="button" class="cws-buy-addmini" data-cws-buy-addchip aria-haspopup="dialog" aria-expanded="false" aria-label="' + esc(t.addChipAria) + '">' + icon('plus') + '<span>' + esc(t.addChip) + '</span></button>';
    out += '<button type="button" class="cws-refresh" data-cws-refresh aria-label="' + esc(t.refreshAria) + '">' + icon('refresh', 'cws-refresh-icon') + '<span>' + esc(t.refreshLabel) + '</span></button>';
    out += '<button type="button" class="cws-buy-add" data-cws-addmany><span data-cws-addmany-ic>' + icon('plus') + '</span><span data-cws-addmany-lbl>' + esc(t.addMany) + '</span></button>';
    out += '</div>';
    out += '</div>';
    out += '<span class="cws-refresh-msg" data-cws-refresh-msg aria-live="polite"></span>';
    out += '</div>';

    /* paneel om zelf een product toe te voegen: zelfde soort popover/bottom sheet (portal)
       als Voorkeuren, met een eigen achtergrond */
    out += '<div class="cws-add-panel" data-cws-add-panel role="dialog" aria-modal="true" aria-labelledby="cws-add-title" hidden>';
    out += '<div class="cws-prefs-head"><h3 class="cws-prefs-title" id="cws-add-title">' + esc(t.addTitle) + '</h3>' +
      '<button type="button" class="cws-add-close" data-cws-add-close aria-label="' + esc(t.prefsCloseAria) + '">' + icon('close') + '</button></div>';
    out += '<div class="cws-add-search-wrap">' + icon('search', 'cws-add-search-ic') + '<input type="search" enterkeyhint="search" autocomplete="off" class="cws-add-search" data-cws-add-search placeholder="' + esc(t.addSearchPh) + '" aria-label="' + esc(t.addSearchAria) + '"></div>';
    out += '<div class="cws-add-chips" data-cws-add-fr role="group"></div>';
    out += '<div class="cws-add-chips" data-cws-add-kind role="group"></div>';
    out += '<div class="cws-add-count" data-cws-add-count aria-live="polite"></div>';
    out += '<div class="cws-add-list" data-cws-add-list></div>';
    out += '</div>';
    out += '<div class="cws-prefs-backdrop" data-cws-add-backdrop hidden></div>';

    /* 5. scroll-cue */
    out += '<button type="button" class="cws-scrollcue2 cws-a cws-a-fade" data-cws-scroll style="--d:' + dScroll + 'ms">';
    out += '<span>' + esc(t.scrollLabel) + '</span><i class="cws-scrollcue2-dot">' + icon('arrowdown', 'cws-scrollcue2-arrow') + '</i>';
    out += '</button>';

    /* achtergrond van het voorkeurenpaneel: dekt het hele component zodat een klik ernaast
       altijd sluit, ongeacht waar het paneel zelf is geankerd */
    out += '<div class="cws-prefs-backdrop" data-cws-prefs-backdrop hidden></div>';

    out += '</div>';
    out += '</section>';
    return out;
  }

  /* ---------------- mount / replay / unmount ---------------- */
  var STATE = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function findRoot(root) {
    if (!root) return null;
    if (root.classList && root.classList.contains('cws')) return root;
    return root.querySelector ? root.querySelector('.cws') : null;
  }
  function setState(el, s) { if (STATE) STATE.set(el, s); else el.__cwsState = s; }
  function getState(el) { return STATE ? STATE.get(el) : el.__cwsState; }

  function mount(root, ctx) {
    var el = findRoot(root);
    if (!el) return;
    var reduced = prefersReduced();
    if (reduced) el.classList.add('cws-reduced');

    var prefs = resolvePrefs(ctx);
    var typeCats = deriveTypeCats(ctx.products);
    var typePrefs = resolveTypePrefs(typeCats.map(function (c) { return c.id; }));
    var state = {
      ctx: ctx, reduced: reduced, timers: [],
      budget: prefs.budget, franchise: prefs.franchise, seed: prefs.seed,
      lastItems: [], addTimer: null, mount3DCtls: {},
      sliderDebounceTimer: null, budgetShown: prefs.budget, totalShown: 0,
      cardCtls: {}, typeCats: typeCats, typePrefs: typePrefs,
      isManual: false, manualItems: null, replaceSeen: {},
      /* bevestiging na "Zet in mandje" (eigenaar 6 okt): confirmed = null zolang er geen
         bevestiging toont; excludeHandles = tijdelijk gezet door "Stel een nieuwe samen"
         (wireConfirmActions), currentBasket() filtert daarmee 1 keer de net toegevoegde
         producten weg, direct erna weer leeg */
      confirmed: null, excludeHandles: null
    };
    setState(el, state);

    if (!ctx.products || !ctx.products.length) { playIntro(el, reduced); return; }

    wireFranchise(el, ctx, state);
    wireSegMark(el, state);
    wireSlider(el, ctx, state);
    wireCustomAmount(el, ctx, state);
    wireRefresh(el, ctx, state);
    wireAddMany(el, ctx, state);
    wireConfirmActions(el, ctx, state);
    wirePrefs(el, ctx, state);
    wireManualBanner(el, ctx, state);
    wireAddPanel(el, ctx, state);
    wireScroll(el, ctx);
    wireCarousel(el, ctx, state);
    wireEmptyActions(el, ctx, state);

    adjustMobilePipClearance(el);
    updateBasket(el, ctx, state, true);
    playIntro(el, reduced);

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        if (state.roRaf) return;
        state.roRaf = requestAnimationFrame(function () {
          state.roRaf = null;
          var box = el.querySelector('[data-cws-stackbox]');
          var track = el.querySelector('[data-cws-stack]');
          if (box && track) updateCarouselControls(el, box, track, state);
        });
      });
      ro.observe(el);
      state.resizeObserver = ro;
    }
  }

  /* op smalle breedtes (mobiel) schuift de slider precies zo ver naar beneden dat hij start
     onder de PiP-hoogte, zonder meer ruimte te verspillen dan nodig. */
  function adjustMobilePipClearance(el) {
    var slider = el.querySelector('.cws-slider-wrap');
    if (!slider) return;
    if (el.clientWidth > 460) { slider.style.marginTop = ''; return; }
    var pipH = parseFloat(getComputedStyle(el).getPropertyValue('--cws-pip-h')) || 0;
    if (!pipH) { slider.style.marginTop = ''; return; }
    var label = el.querySelector('.cws-budget-label');
    if (!label) { slider.style.marginTop = ''; return; }
    var elTop = el.getBoundingClientRect().top;
    var labelBottom = label.getBoundingClientRect().bottom - elTop;
    var needed = Math.max(0, pipH - labelBottom);
    slider.style.marginTop = needed ? (needed + 'px') : '';
  }

  function playIntro(el, reduced) {
    el.classList.remove('cws-play');
    void el.offsetWidth;
    requestAnimationFrame(function () { el.classList.add('cws-play'); });
  }

  function currentBasket(ctx, state) {
    /* een eigen (handmatig aangepaste) selectie wint altijd: budget/franchise wijzigen die
       niet stilzwijgend meer (eigenaar 5 okt) */
    state.lastEffPrefs = effectiveTypePrefs(ctx, state);
    if (state.isManual && state.manualItems) {
      return { items: state.manualItems, total: manualTotal(state.manualItems), prefFallback: false, manual: true };
    }
    /* excludeHandles (tijdelijk, enkel gezet door "Stel een nieuwe samen"): de net toegevoegde
       producten even uit de pool filteren zodat de nieuwe selectie er zeker niet opnieuw in zit */
    var products = ctx.products;
    if (state.excludeHandles && state.excludeHandles.length) {
      products = (products || []).filter(function (p) { return state.excludeHandles.indexOf(p.handle) === -1; });
    }
    var basket = composeFor(ctx, state, products, state.seed);
    state.lastEffPrefs = basket.eff;
    basket.prefSource = basket.eff.source;
    return basket;
  }

  function persist(state) { savePrefs(state.budget, state.franchise, state.seed); }

  /* overal waar de selectie echt verandert (budget, franchise, aantal, vervangen, een nieuwe
     selectie, ...) roept de bestaande code dit al aan vlak voor updateBasket: dus hier ook de
     bevestigingskaart na "Zet in mandje" opruimen (eigenaar 6 okt, punt 4: geen dubbel
     toevoegen zolang niets wijzigt, maar meteen weer normaal zodra iets wel wijzigt) */
  function resetAddButton(el, ctx, state) {
    if (state.addTimer) { clearTimeout(state.addTimer); state.addTimer = null; }
    state.confirmed = null;
    hideConfirmCard(el);
    var btn = el.querySelector('[data-cws-addmany]');
    if (!btn) return;
    var t = strFor(ctx.lang);
    btn.classList.remove('cws-done');
    var ic = btn.querySelector('[data-cws-addmany-ic]'), lbl = btn.querySelector('[data-cws-addmany-lbl]');
    if (ic) ic.innerHTML = icon('plus');
    if (lbl) lbl.textContent = t.addMany;
  }
  /* bevestigingskaart verbergen: 1 klasse op .cws-stackbox regelt zowel het terugtonen van de
     echte productkaarten als het verbergen van de kaart (zie start-scene.css); wordt altijd
     gevolgd door een updateBasket (zet pijlen/teller/car-empty weer correct) behalve wanneer er
     toch niets te tonen viel (dan was de kaart al verborgen, dit is dan een no-op) */
  function hideConfirmCard(el) {
    var stackbox = el.querySelector('[data-cws-stackbox]');
    if (stackbox) stackbox.classList.remove('cws-confirmed');
  }
  /* bevestigingskaart tonen en vullen: state.confirmed staat al klaar (zie wireAddMany). de
     carrousel-pijlen en -teller gaan uit zolang de kaart toont (geen updateBasket nodig: de
     selectie zelf is niet veranderd door toe te voegen, enkel de weergave verandert). */
  function showConfirmCard(el, ctx, state) {
    var t = strFor(ctx.lang);
    var c = state.confirmed;
    var stackbox = el.querySelector('[data-cws-stackbox]');
    var card = el.querySelector('[data-cws-car-confirm]');
    if (!stackbox || !card || !c) return;
    var titleEl = card.querySelector('[data-cws-confirm-title]');
    var lineEl = card.querySelector('[data-cws-confirm-line]');
    var thumbsEl = card.querySelector('[data-cws-confirm-thumbs]');
    var newBtn = card.querySelector('[data-cws-confirm-new]');
    var cartBtn = card.querySelector('[data-cws-confirm-cart]');
    var undoBtn = card.querySelector('[data-cws-confirm-undo]');
    if (titleEl) titleEl.textContent = t.added;
    if (lineEl) lineEl.textContent = t.confirmLine(c.count, c.total);
    if (thumbsEl) thumbsEl.innerHTML = c.items.map(function (it) { return '<img src="' + esc(ctx.img(it.handle)) + '" alt="" loading="lazy">'; }).join('');
    if (newBtn) newBtn.textContent = t.confirmNewBtn;
    if (cartBtn) cartBtn.textContent = t.confirmCartBtn;
    if (undoBtn) undoBtn.textContent = t.confirmUndo;
    var prev = el.querySelector('[data-cws-car-prev]'), next = el.querySelector('[data-cws-car-next]'), counter = el.querySelector('[data-cws-car-counter]');
    if (prev) prev.hidden = true;
    if (next) next.hidden = true;
    if (counter) counter.hidden = true;
    stackbox.classList.add('cws-confirmed');
  }

  /* ---------------- budget tonen: direct tijdens het slepen, vloeiend tellend bij elke
     andere wijziging (franchise, vernieuwen, eigen bedrag, loslaten van de slider) ---------------- */
  function setBudgetDisplay(el, state, animate) {
    var valEl = el.querySelector('[data-cws-val]');
    if (!valEl) return;
    var pencil = valEl.querySelector('.cws-budget-pencil');
    var from = state.budgetShown == null ? state.budget : state.budgetShown;
    function paint(v) {
      valEl.innerHTML = eurWholeHtml(v) + (pencil ? pencil.outerHTML : icon('pencil', 'cws-budget-pencil'));
    }
    if (!animate) { paint(state.budget); state.budgetShown = state.budget; return; }
    animateNumber(from, state.budget, 300, function (v) { paint(v); }, state.reduced);
    state.budgetShown = state.budget;
  }
  function setTotalDisplay(el, state, newTotal, animate) {
    var totalEl = el.querySelector('[data-cws-total]');
    if (!totalEl) return;
    var from = state.totalShown == null ? 0 : state.totalShown;
    function paint(v) { totalEl.innerHTML = buyHtml(Math.max(0, v)); }
    if (!animate) { paint(newTotal); state.totalShown = newTotal; return; }
    animateNumber(from, newTotal, 300, function (v) { paint(v); }, state.reduced);
    state.totalShown = newTotal;
  }
  function updateFillBar(el, state) {
    var fillEl = el.querySelector('[data-cws-fill]');
    if (fillEl) fillEl.style.width = (posFromBudget(state.budget) * 100) + '%';
  }

  function updateBasket(el, ctx, state, isFirst) {
    var t = strFor(ctx.lang);
    var basket = currentBasket(ctx, state);
    var prevItems = state.lastItems || [];
    state.lastItems = basket.items;

    setBudgetDisplay(el, state, !isFirst);
    updateFillBar(el, state);
    setTotalDisplay(el, state, basket.total, !isFirst && prevItems.length === basket.items.length ? true : !isFirst);
    updatePrefsLine(el, t, state);

    renderBuyPanel(el, ctx, state, basket, t, isFirst);
    /* eigenaar 6 okt: de regel "... beginnen bij" eerst zijn plaats laten innemen, anders berekent renderStack de
       fotohoogte zonder die regel en schuift hij daarna de kaarten onderaan uit beeld */
    var fbPre = el.querySelector('[data-cws-pref-fallback]');
    var raisedOn = !!(state.raised && state.raised.text && state.raised.budget === state.budget && !basket.prefFallback && basket.items.length > 0);
    if (!raisedOn) state.raised = null;
    if (fbPre) { var fbOn = (!!basket.prefFallback && basket.items.length > 0) || raisedOn; fbPre.hidden = !fbOn; if (fbOn && !fbPre.textContent) fbPre.textContent = '\u00a0'; }
    renderStack(el, ctx, state, basket.items, isFirst);
    renderCarEmpty(el, ctx, state, basket, t);

    var fbEl = el.querySelector('[data-cws-pref-fallback]');
    if (fbEl) {
      var showFb = !!basket.prefFallback && basket.items.length > 0;
      fbEl.hidden = !(showFb || raisedOn);
      if (raisedOn && !showFb) fbEl.textContent = state.raised.text;
      if (showFb) {
        var fbTypes = state.lastEffPrefs.types, fbFrom = null;
        (ctx.products || []).forEach(function (p) {
          if (!p || p.av === false || p.type === 'acc' || !productMatchesFranchise(p, state.franchise)) return;
          if (fbTypes.indexOf(classifyProduct(p)) !== -1 && (fbFrom == null || p.price < fbFrom)) fbFrom = p.price;
        });
        fbEl.textContent = t.prefsFallbackLine(joinCatLabels(fbTypes, t, false), fbFrom);
      }
    }
  }

  /* het regeltje "Vooral ..." / "CARDIX kiest ..." onder de tabs, plus het bolletje op de
     knop "Voorkeuren" zelf wanneer er een eigen keuze actief is. */
  function updatePrefsLine(el, t, state) {
    var lineEl = el.querySelector('[data-cws-prefs-line]');
    if (lineEl) lineEl.textContent = prefsLineText(t, state.lastEffPrefs || { mode: 'auto', types: [], source: 'none' });
    if (state.syncPrefsUI) state.syncPrefsUI();
    var trigger = el.querySelector('[data-cws-prefs-btn]');
    if (!trigger) return;
    var badge = trigger.querySelector('[data-cws-prefs-badge]');
    var n = prefsActiveCount(state.typePrefs);
    if (n) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cws-prefs-badge';
        badge.setAttribute('data-cws-prefs-badge', '');
        trigger.appendChild(badge);
      }
      badge.textContent = String(n);
    } else if (badge) { badge.parentNode.removeChild(badge); }
  }

  /* ---------------- koopblok: 1 compacte rij (geen chiprij meer, eigenaar 5 okt): links
     aantal + totaal (of, leeg, de korte zin), rechts Voeg toe, Andere selectie, Zet in
     mandje. verwijderen/vervangen/aantal zitten op de carrousel-items zelf. ---------------- */
  function renderBuyPanel(el, ctx, state, basket, t, isFirst) {
    var countEl = el.querySelector('[data-cws-buy-count]');
    var totalEl = el.querySelector('[data-cws-total]');
    var addBtn = el.querySelector('[data-cws-addmany]');
    var hasItems = basket.items.length > 0;

    el.classList.toggle('cws-buy-is-empty', !hasItems);
    if (countEl) { countEl.hidden = !hasItems; if (hasItems) countEl.textContent = t.buyCount(basket.items.length); }
    if (totalEl) { totalEl.hidden = !hasItems; if (hasItems) totalEl.innerHTML = buyHtml(basket.total); }
    var thumbsEl = el.querySelector('[data-cws-buy-thumbs]');
    if (thumbsEl) {
      /* max 5 miniaturen, daarna +N; enkel opnieuw opbouwen als de selectie echt veranderde (geen knipperende foto's) */
      var key = basket.items.map(function (it) { return it.handle; }).join('|');
      if (thumbsEl.getAttribute('data-key') !== key) {
        thumbsEl.setAttribute('data-key', key);
        var shown = basket.items.slice(0, 5), more = basket.items.length - shown.length;
        thumbsEl.innerHTML = shown.map(function (it) { return '<img src="' + esc(ctx.img(it.handle)) + '" alt="" loading="lazy">'; }).join('') +
          (more > 0 ? '<span class="cws-buy-more">+' + more + '</span>' : '');
      }
    }
    var emptyLineEl = el.querySelector('[data-cws-buy-empty-line]');
    if (emptyLineEl) {
      emptyLineEl.hidden = hasItems;
      if (!hasItems) emptyLineEl.textContent = t.buyEmptyLine(basket.cheapest != null ? basket.cheapest : 10);
    }
    if (addBtn) { if (hasItems) addBtn.removeAttribute('aria-disabled'); else addBtn.setAttribute('aria-disabled', 'true'); }

    /* "Je hebt je selectie aangepast" + "Herstel voorstel": enkel bij een eigen selectie,
       niet in de lege stand (geen aantal/totaal is al genoeg uitleg) */
    var manualBanner = el.querySelector('[data-cws-manual-banner]');
    if (manualBanner) {
      var showManual = !!state.isManual && hasItems;
      manualBanner.hidden = !showManual;
      if (showManual) {
        var txt = manualBanner.querySelector('[data-cws-manual-text]');
        if (txt) txt.textContent = t.manualLine;
        var rb = manualBanner.querySelector('[data-cws-manual-restore]');
        if (rb) rb.textContent = t.manualRestore;
      }
    }
    /* toevoegen mag het budget overschrijven: het totaal kleurt niet rood, enkel een klein
       regeltje eronder (eigenaar 5 okt) */
    var overEl = el.querySelector('[data-cws-over-budget]');
    if (overEl) {
      var overAmt = hasItems ? round2(basket.total - state.budget) : 0;
      overEl.hidden = overAmt <= 0.004;
      if (overAmt > 0.004) overEl.textContent = t.overBudgetLine(overAmt);
    }
  }

  /* lege stand in de carrousel zelf: rustig icoon, titel, zin met de echte laagste prijs van
     de gekozen franchise, en 2 knoppen die naar een werkende selectie springen. */
  function renderCarEmpty(el, ctx, state, basket, t) {
    var box = el.querySelector('[data-cws-car-empty]');
    if (!box) return;
    var hasItems = basket.items.length > 0;
    box.hidden = hasItems;
    if (hasItems) return;
    var fLabel = franchiseLabel(t, state.franchise);
    var price = basket.cheapest != null ? basket.cheapest : cheapestInFranchise(ctx.products, state.franchise);
    var titleEl = box.querySelector('[data-cws-car-empty-title]');
    var textEl = box.querySelector('[data-cws-car-empty-text]');
    var minBtn = box.querySelector('[data-cws-set-min]');
    if (titleEl) titleEl.textContent = t.carEmptyTitle;
    if (textEl) textEl.textContent = price != null ? t.carEmptyText(fLabel, price) : '';
    if (minBtn) {
      if (price != null) { minBtn.hidden = false; minBtn.textContent = t.carSetMin(Math.ceil(price)); minBtn.setAttribute('data-price', String(Math.ceil(price))); }
      else minBtn.hidden = true;
    }
    /* het goedkoopste product van die franchise als klikbaar voorproefje */
    var peek = box.querySelector('[data-cws-empty-peek]');
    if (peek) {
      var cp = (ctx.products || []).filter(function (p) { return p && p.av !== false && p.type !== 'acc' && productMatchesFranchise(p, state.franchise); })
        .sort(function (a, b) { return a.price - b.price; })[0];
      if (cp) {
        peek.hidden = false;
        peek.setAttribute('data-handle', cp.handle);
        peek.setAttribute('aria-label', cp.title || '');
        peek.innerHTML = '<img src="' + esc(ctx.img(cp.handle)) + '" alt=""><span class="cws-peek-txt"><span class="cws-peek-k">' + esc(t.carEmptyPeek) + '</span><span class="cws-peek-n">' + esc(cp.title || '') + '</span></span><span class="cws-peek-p">' + esc(eurPlainNL(cp.price)) + '</span>';
      } else peek.hidden = true;
    }
    var track = el.querySelector('[data-cws-stack]');
    if (track) { track.style.justifyContent = 'center'; }
    var prev = el.querySelector('[data-cws-car-prev]'), next = el.querySelector('[data-cws-car-next]'), counter = el.querySelector('[data-cws-car-counter]');
    if (prev) prev.hidden = true;
    if (next) next.hidden = true;
    if (counter) counter.hidden = true;
  }

  function wireEmptyActions(el, ctx, state) {
    var minBtn = el.querySelector('[data-cws-set-min]');
    var mixBtn = el.querySelector('[data-cws-set-mix]');
    if (minBtn) minBtn.addEventListener('click', function () {
      var price = parseInt(minBtn.getAttribute('data-price'), 10);
      state.isManual = false; state.manualItems = null;
      if (!isNaN(price)) applyBudget(el, ctx, state, price);
    });
    var peekBtn = el.querySelector('[data-cws-empty-peek]');
    if (peekBtn) peekBtn.addEventListener('click', function () {
      var h = peekBtn.getAttribute('data-handle');
      if (h && ctx.on && ctx.on.product) ctx.on.product(h, peekBtn.querySelector('img') || peekBtn);
    });
    if (mixBtn) mixBtn.addEventListener('click', function () {
      state.franchise = 'mix';
      state.isManual = false; state.manualItems = null;
      persist(state);
      setFranchiseUI(el, 'mix');
      resetAddButton(el, ctx, state);
      clearRefreshMsg(el);
      updateBasket(el, ctx, state, false);
    });
  }
  function setFranchiseUI(el, key) {
    var seg = el.querySelector('.cws-seg[data-group="franchise3"]');
    if (!seg) return;
    var mark = seg.querySelector('.cws-seg-mark');
    var btns = Array.prototype.slice.call(seg.querySelectorAll('button'));
    btns.forEach(function (b, i) {
      var on = b.getAttribute('data-franchise3') === key;
      b.classList.toggle('cws-on', on);
      if (on && mark) mark.style.setProperty('--i', String(i));
    });
    placeSegMark(seg);
  }
  /* markering exact onder de actieve knop: positie en breedte meten i.p.v. gelijke delen */
  function placeSegMark(seg) {
    var mark = seg && seg.querySelector('.cws-seg-mark');
    var on = seg && seg.querySelector('button.cws-on');
    if (!mark || !on || !on.offsetWidth) return;
    /* rechtstreeks zetten (niet via een custom property in transform: die werd niet altijd
       opnieuw berekend, waardoor de markering een klik achterliep) */
    mark.style.width = on.offsetWidth + 'px';
    mark.style.transform = 'translateX(' + on.offsetLeft + 'px)';
  }
  function wireSegMark(el, state) {
    var seg = el.querySelector('.cws-seg[data-group="franchise3"]');
    if (!seg) return;
    var mark = seg.querySelector('.cws-seg-mark');
    if (mark) { mark.style.transition = 'none'; placeSegMark(seg); void mark.offsetWidth; mark.style.transition = ''; }
    try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { placeSegMark(seg); }); } catch (e) { /* negeren */ }
    if (window.ResizeObserver) {
      try { var ro = new ResizeObserver(function () { placeSegMark(seg); }); ro.observe(seg); state.segObserver = ro; } catch (e) { /* negeren */ }
    }
  }

  /* ---------------- generieke keyed reconciliatie: hergebruikt bestaande knooppunten op
     basis van een sleutel (geen nieuwe mount3D, geen herstart), herschikt ze in de juiste
     volgorde (FLIP, enkel transform) en faadt wat weggaat uit / wat nieuw is staffelend in.
     wordt gebruikt voor zowel de carrousel als de kaartjes in het koopblok. ---------------- */
  function reconcileKeyed(container, items, keyFn, handlers, state, isFirst, animPrefix) {
    var prevKeys = container.__cwsKeys || [];
    var newKeys = items.map(keyFn);
    var prevNodes = {};
    prevKeys.forEach(function (k) {
      var n = container.querySelector('[data-key="' + cssEsc(k) + '"]:not(.cws-leaving)');
      if (n) prevNodes[k] = n;
    });

    var oldLeft = {};
    if (!isFirst && !state.reduced) {
      newKeys.forEach(function (k) {
        if (prevNodes[k]) oldLeft[k] = prevNodes[k].getBoundingClientRect().left;
      });
    }

    /* vertrekkers meteen uit de flow halen (absoluut op hun huidige plek), zodat ze geen
       lege plaats meer innemen en de blijvers direct naar hun nieuwe plek schuiven. eerst
       alle posities meten, dan pas wijzigen (geen layout-sprongen tussendoor). */
    var leaving = prevKeys.filter(function (k) { return newKeys.indexOf(k) === -1 && prevNodes[k]; });
    if (leaving.length && !state.reduced) {
      if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
      var pos = leaving.map(function (k) { var n = prevNodes[k]; return { l: n.offsetLeft, t: n.offsetTop, w: n.offsetWidth }; });
      leaving.forEach(function (k, i) {
        var n = prevNodes[k];
        n.classList.add('cws-leaving');
        n.removeAttribute('data-key');
        n.classList.remove('cws-has-3d', 'cws-3d-ready');
        n.style.position = 'absolute'; n.style.left = pos[i].l + 'px'; n.style.top = pos[i].t + 'px';
        n.style.width = pos[i].w + 'px'; n.style.margin = '0';
      });
    }
    prevKeys.forEach(function (k) {
      if (newKeys.indexOf(k) !== -1) return;
      var node = prevNodes[k];
      if (!node) return;
      if (handlers.onRemove) handlers.onRemove(k);
      if (state.reduced) { if (node.parentNode) node.parentNode.removeChild(node); return; }
      node.classList.add(animPrefix + '-out');
      var done = false;
      function cleanup() { if (done) return; done = true; if (node.parentNode) node.parentNode.removeChild(node); }
      node.addEventListener('animationend', cleanup, { once: true });
      state.timers.push(setTimeout(cleanup, 420));
    });

    items.forEach(function (it, i) {
      var key = keyFn(it);
      var node = prevNodes[key];
      var isNew = !node;
      if (isNew) {
        node = handlers.build(it, i);
        node.setAttribute('data-key', key);
        if (handlers.update) handlers.update(node, it, i);
        if (!state.reduced && !isFirst) {
          node.classList.add(animPrefix + '-in');
          node.style.animationDelay = Math.min(i, 8) * 40 + 'ms';
          node.addEventListener('animationend', function () { node.classList.remove(animPrefix + '-in'); node.style.animationDelay = ''; }, { once: true });
        }
        container.appendChild(node);
      } else {
        node.classList.remove(animPrefix + '-out');
        handlers.update(node, it, i);
        container.appendChild(node); /* herschikt in de juiste volgorde */
      }
    });

    container.__cwsKeys = newKeys;

    /* vangnet: elk kind met een sleutel die niet (meer) in de selectie zit en niet aan het
       vertrekken is, is een wees (bv. na snel na elkaar wisselen) en neemt anders onzichtbaar
       plaats in, waardoor een enkel product uit het midden schuift */
    Array.prototype.slice.call(container.children).forEach(function (c) {
      var ck = c.getAttribute && c.getAttribute('data-key');
      if (ck != null && newKeys.indexOf(ck) === -1 && !c.classList.contains('cws-leaving')) {
        if (handlers.onDiscard && !c.__cwsOrphanDone) { c.__cwsOrphanDone = true; handlers.onDiscard(c); }
        c.parentNode.removeChild(c);
      }
    });
    /* en per sleutel maar 1 knoop: dubbele (oudere) exemplaren weg */
    newKeys.forEach(function (k) {
      var all = container.querySelectorAll('[data-key="' + cssEsc(k) + '"]:not(.cws-leaving)');
      for (var di = 0; di < all.length - 1; di++) { if (handlers.onDiscard) handlers.onDiscard(all[di]); if (all[di].parentNode) all[di].parentNode.removeChild(all[di]); }
    });

    if (!isFirst && !state.reduced) {
      requestAnimationFrame(function () {
        newKeys.forEach(function (k) {
          if (oldLeft[k] == null) return;
          var node = container.querySelector('[data-key="' + cssEsc(k) + '"]');
          if (!node) return;
          var newLeft = node.getBoundingClientRect().left;
          var delta = oldLeft[k] - newLeft;
          if (Math.abs(delta) < 0.5) return;
          node.style.transition = 'none';
          node.style.transform = 'translateX(' + delta + 'px)';
          void node.offsetWidth;
          node.style.transition = 'transform .35s ease-out';
          node.style.transform = 'none';
          node.addEventListener('transitionend', function te() { node.style.transition = ''; node.removeEventListener('transitionend', te); }, { once: true });
        });
      });
    }
  }

  /* carrousel: elk item krijgt zijn eigen beeldzone (mount3D per item, met destroy() van de
     vorige bij een nieuwe selectie; levert mount3D zelf al een tijdelijke foto, dus zonder
     controller komt er GEEN eigen <img> bij) of, zonder mount3D, een los sleepbare uitsnede
     met een eigen cutout die meteen zichtbaar is en pas crossfadet zodra de 3D-mount klaar
     lijkt (nooit een lege flits). onder elk item een label met naam, aantalbadge en prijs,
     op een zacht podium (geen losse zwevende tekst). */
  /* gewone foto (tins, blisters, en de foto voor de 3D klaar is): zelfde regel als het 3D-model in mountHero3D,
     ongeveer de helft van het vak als oppervlakte, nooit breder dan 90% of hoger dan 96%, onderaan uitgelijnd */
  function fitFallbackImg(img) {
    var box = img.parentNode, W = box.clientWidth, H = box.clientHeight, nw = img.naturalWidth, nh = img.naturalHeight;
    if (!W || !H || !nw || !nh) return;
    /* dozen 72%, packs 50% (data-area, zelfde regel als het 3D-model): de platte bundel kreeg eerst de pack-maat */
    var r = fitRect(W, H, nw / nh, +img.getAttribute('data-area') || .5);
    img.style.width = r.w + 'px'; img.style.height = r.h + 'px';
  }
  /* skelet op de maat van het product zolang er nog niets te zien is (foto laadt, 3D monteert) */
  function sizeSkel(node, ctx, handle, imgH) {
    var sk = node.querySelector('[data-cws-skel] i'); if (!sk) return;
    var r = fitRect(parseFloat(node.style.width) || ITEM_W, Math.max(20, imgH - ITEM_FIT_GAP), itemAr(ctx, handle) || .72, itemFitArea(ctx, handle));
    sk.style.width = r.w + 'px'; sk.style.height = r.h + 'px';
  }
  function renderStack(el, ctx, state, items, isFirst) {
    var t = strFor(ctx.lang);
    var box = el.querySelector('[data-cws-stackbox]');
    var track = el.querySelector('[data-cws-stack]');
    if (!box || !track) return;

    var prevKeys = track.__cwsKeys || [];
    var prevItems = state.lastStackItems || [];
    var isGenuinelyNew = !sameHandleSet(prevItems, items);
    var visibleKeyBefore = null;
    if (isGenuinelyNew && prevKeys.length) {
      visibleKeyBefore = prevKeys[stackIdxAt(track)] || null;
    }
    state.lastStackItems = items;

    var isNarrow = box.clientWidth <= 460;
    var imgH = computeItemImgH(box.clientHeight, isNarrow);

    reconcileKeyed(track, items, function (it) { return it.handle; }, {
      onRemove: function (key) {
        var ctl = state.mount3DCtls[key];
        if (ctl && typeof ctl.destroy === 'function') { try { ctl.destroy(); } catch (e) { /* stil negeren */ } }
        delete state.mount3DCtls[key];
      },
      /* wees of dubbel exemplaar (zonder onRemove weggehaald): enkel de eigen 3D-mount van die knoop opruimen */
      onDiscard: function (n) {
        var c = n.__cwsCtl; if (!c) return;
        n.__cwsCtl = null;
        if (typeof c.destroy === 'function') { try { c.destroy(); } catch (e) { /* stil negeren */ } }
        Object.keys(state.mount3DCtls).forEach(function (k) { if (state.mount3DCtls[k] === c) delete state.mount3DCtls[k]; });
      },
      build: function (it, i) {
        var node = document.createElement('div');
        node.className = 'cws-stack-item';
        node.setAttribute('data-cws-stack-item', '');
        node.setAttribute('data-handle', it.handle);
        node.style.width = itemW(ctx, it.handle) + 'px';
        node.innerHTML =
          '<div class="cws-stack-imgzone" data-cws-stack-img>' +
            '<div class="cws-imgzone-fallback" data-cws-fallback></div><div class="cws-imgzone-3d" data-cws-3d></div>' +
            '<div class="cws-skel" data-cws-skel aria-hidden="true"><i></i></div>' +
            '<div class="cws-item-edit-acts">' +
              '<button type="button" class="cws-remove-btn cws-remove-btn-item" data-cws-remove aria-label="' + esc(t.removeAria) + '">' + icon('close') + '</button>' +
              '<button type="button" class="cws-replace-btn cws-replace-btn-item" data-cws-replace aria-label="' + esc(t.replaceAria) + '">' + icon('swap') + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="cws-stack-label">' +
            '<div class="cws-stack-label-text" data-cws-label-text></div>' +
          '</div>';
        var imgzone = node.querySelector('[data-cws-stack-img]');
        var fallback = node.querySelector('[data-cws-fallback]');
        var threeD = node.querySelector('[data-cws-3d]');
        /* de eerste producten (wat meteen in beeld staat) niet lazy laden: lazy in een horizontale carrousel wachtte te lang */
        fallback.innerHTML = '<img src="' + esc(ctx.img(it.handle)) + '" alt="' + esc(it.title || '') + '" data-area="' + itemFitArea(ctx, it.handle) + '" decoding="async" loading="' + (i < 6 ? 'eager' : 'lazy') + '">';
        var fbImg = fallback.querySelector('img');
        var fbOk = function () { fitFallbackImg(fbImg); fallback.classList.add('cws-fb-ok'); };
        fbImg.addEventListener('load', fbOk);
        fbImg.addEventListener('error', function () { fbImg.style.visibility = 'hidden'; fallback.classList.add('cws-fb-ok'); });
        if (fbImg.complete && fbImg.naturalWidth) requestAnimationFrame(fbOk);
        /* verwijderen en vervangen: stopPropagation zodat de drag/klik-logica van de
           beeldzone deze knoppen nooit als een sleep of een opener behandelt. rechtsboven,
           zichtbaar bij hover/focus op desktop, altijd zichtbaar op touch (zie css). */
        node.querySelector('[data-cws-remove]').addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        node.querySelector('[data-cws-remove]').addEventListener('click', function (e) {
          e.stopPropagation();
          removeFromManual(state, it.handle);
          resetAddButton(el, ctx, state);
          updateBasket(el, ctx, state, false);
        });
        node.querySelector('[data-cws-replace]').addEventListener('pointerdown', function (e) { e.stopPropagation(); });
        node.querySelector('[data-cws-replace]').addEventListener('click', function (e) {
          e.stopPropagation();
          var ok = replaceInManual(ctx, state, it.handle);
          resetAddButton(el, ctx, state);
          if (ok) { updateBasket(el, ctx, state, false); }
          else { showRefreshMsg(el, state, t.replaceNoAlt); }
        });
        var ctl = null;
        if (ctx.mount3D) { try { ctl = ctx.mount3D(threeD, it.handle); } catch (e) { ctl = null; } }
        if (ctl) {
          state.mount3DCtls[it.handle] = ctl;
          node.__cwsCtl = ctl;
          /* geen echte "klaar"-terugroep in dit contract: de echte foto blijft zichtbaar
             tot de 3D-laag een korte, vaste tijd kreeg om te monteren, dan kruisfadet het
             (nooit een lege flits, wel een rustige overgang in plaats van een harde wissel) */
          /* 3D-items tonen geen foto vooraf (die is groter dan het model en gaf een
             groot-dan-klein-sprong): het model fadet in zodra de 3D-laag echt klaar is
             (cws-h3d-on). Lukt dat niet binnen 2,5 s (bv. geen vrije 3D-instantie), dan
             fadet de foto alsnog in. */
          node.classList.add('cws-has-3d');
          var waited = 0;
          var poll = setInterval(function () {
            waited += 80;
            if (threeD.classList.contains('cws-h3d-on')) { clearInterval(poll); node.classList.add('cws-3d-ready'); }
            else if (waited >= 2500 || !node.isConnected) { clearInterval(poll); node.classList.remove('cws-has-3d'); }
          }, 80);
          state.timers.push(poll);
          /* de pool in app.js geeft een 3D-instantie aan wat in beeld is en neemt ze terug van wat uit beeld schuift:
             'cws-h3d' meldt elke wissel, ook na de 2,5 s hierboven (dan kruisfadet de foto alsnog naar het model) */
          threeD.addEventListener('cws-h3d', function (e) {
            if (e.detail && e.detail.on) node.classList.add('cws-has-3d', 'cws-3d-ready');
            else node.classList.remove('cws-3d-ready', 'cws-has-3d');
          });
        }
        /* de foto is altijd los te draaien, ook bij een 3D-product dat (nog) geen instantie heeft; zodra het
           3D-model staat, doet dat het draaien (anders pakt de beeldzone de pointer af van het model) */
        wireRotateVisual(imgzone, state, function () { return node.classList.contains('cws-3d-ready'); });
        wireClickVsDrag(imgzone, state, function () { if (ctx.on && ctx.on.product) ctx.on.product(it.handle, imgzone); });
        return node;
      },
      update: function (node, it) {
        var labelTextEl = node.querySelector('[data-cws-label-text]');
        if (labelTextEl) {
          var maxQ = MANUAL_QTY_MAX;
          var sub = it.qty >= 1
            ? ('<span class="cws-stack-qtywrap" data-cws-qtywrap>' +
                '<button type="button" class="cws-qty-btn cws-qty-minus" data-cws-qty-minus aria-label="' + esc(t.qtyMinusAria) + '">' + icon('minus') + '</button>' +
                '<span class="cws-stack-qty">' + it.qty + 'x</span>' +
                '<button type="button" class="cws-qty-btn cws-qty-plus" data-cws-qty-plus aria-label="' + esc(t.qtyPlusAria) + '"' + (it.qty >= maxQ ? ' disabled' : '') + '>' + icon('plus') + '</button>' +
              '</span>')
            : '';
          sub += '<span class="cws-stack-price">' + eurHtml(it.price) + '</span>';
          var kl = kindLabel(ctx, it.handle);
          node.querySelector('.cws-stack-label').title = it.title || '';
          labelTextEl.innerHTML = (boughtSetOf(ctx)[it.handle] ? '<span class="cws-bought">' + esc(t.boughtChip) + '</span>' : '') + '<span class="cws-stack-name">' + esc(shortTitle(it.title)) + '</span><span class="cws-stack-kind">' + esc(kl || '\u00a0') + '</span><span class="cws-stack-sub">' + sub + '</span>';
          /* min bij een aantal van 1 verwijdert het product; plus volgt het bestaande
             maximum voor packs. de knoppen worden elke update opnieuw gezet (de hele
             tekstzone wordt herschreven), dus de listeners hier meteen erbij zetten */
          var minusBtn = labelTextEl.querySelector('[data-cws-qty-minus]');
          if (minusBtn) minusBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            setQtyInManual(state, it.handle, it.qty - 1);
            resetAddButton(el, ctx, state);
            updateBasket(el, ctx, state, false);
          });
          var plusBtn = labelTextEl.querySelector('[data-cws-qty-plus]');
          if (plusBtn) plusBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (it.qty < maxQ) { setQtyInManual(state, it.handle, it.qty + 1); resetAddButton(el, ctx, state); updateBasket(el, ctx, state, false); }
          });
        }
        var imgzoneEl = node.querySelector('[data-cws-stack-img]');
        if (imgzoneEl) imgzoneEl.style.height = imgH + 'px';
        sizeSkel(node, ctx, it.handle, imgH);
      }
    }, state, isFirst, 'cws-item');

    /* beeldzone-hoogte ook voor de (ongewijzigde) items opnieuw zetten, bv. na resize */
    Array.prototype.forEach.call(track.querySelectorAll('[data-cws-stack-img]'), function (z) { z.style.height = imgH + 'px'; });
    Array.prototype.forEach.call(track.querySelectorAll('[data-cws-fallback] img'), fitFallbackImg);
    Array.prototype.forEach.call(track.querySelectorAll('.cws-stack-item[data-handle]:not(.cws-add-tile)'), function (n) { sizeSkel(n, ctx, n.getAttribute('data-handle'), imgH); });

    /* "Voeg toe": blijft als laatste tegel staan, buiten de teller (eigenaar 5 okt) */
    var addTile = el.querySelector('[data-cws-add-tile]');
    if (addTile) {
      addTile.hidden = !items.length; track.appendChild(addTile);
      /* even hoog als een productitem (foto + naamkaartje), anders stond het vak te hoog of te laag (eigenaar 5 okt) */
      var refItem = track.querySelector('.cws-stack-item:not(.cws-add-tile)');
      addTile.style.height = refItem && refItem.offsetHeight ? refItem.offsetHeight + 'px' : '';
    }

    if (isGenuinelyNew) {
      var newKeysNow = track.__cwsKeys || [];
      if (visibleKeyBefore && newKeysNow.indexOf(visibleKeyBefore) !== -1) {
        track.scrollLeft = stackLeft(track, newKeysNow.indexOf(visibleKeyBefore));
      } else {
        track.scrollLeft = 0;
      }
    }
    updateCarouselControls(el, box, track, state);
    state.timers.push(setTimeout(function () { updateCarouselControls(el, box, track, state); }, 460));
  }

  /* pijlen en teller enkel tonen als de rij niet in 1 oogopslag past: gecentreerd zonder
     pijlen zolang alles past, anders links beginnen met scroll-snap, pijlen en een teller
     "1 / n". herberekend bij resize (ResizeObserver) en na elke wissel. */
  function updateCarouselControls(el, box, track, state) {
    if (state.lastStackItems && !state.lastStackItems.length) return; /* lege stand regelt dit zelf */
    var n = (track.__cwsKeys || []).length;
    /* breedte uit de blijvende items berekenen, niet uit scrollWidth: vertrekkers die nog
       uitfaden (absoluut) tellen anders mee en zetten een enkel product links/rechts. de
       "Voeg toe"-tegel valt buiten de teller maar telt wel mee voor of de rij past/scrolt. */
    var addTile = el.querySelector('[data-cws-add-tile]');
    var hasAddTile = !!(addTile && !addTile.hidden);
    var contentW = stackNodes(track).reduce(function (sum, nd, k) { return sum + (parseFloat(nd.style.width) || nd.offsetWidth) + (k ? ITEM_GAP : 0); }, 0) + 8 + (hasAddTile ? ITEM_W + ITEM_GAP : 0);
    var scrollable = contentW > box.clientWidth + 2;
    track.style.justifyContent = scrollable ? 'flex-start' : 'center';
    var prev = el.querySelector('[data-cws-car-prev]');
    var next = el.querySelector('[data-cws-car-next]');
    var counter = el.querySelector('[data-cws-car-counter]');
    if (prev) prev.hidden = !scrollable;
    if (next) next.hidden = !scrollable;
    if (counter) counter.hidden = !scrollable;
    if (!scrollable) return;
    var idx = Math.max(0, Math.min(n - 1, stackIdxAt(track)));
    if (counter) counter.textContent = (idx + 1) + ' / ' + n;
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= track.scrollWidth - box.clientWidth - 2;
  }

  function wireFranchise(el, ctx, state) {
    var seg = el.querySelector('.cws-seg[data-group="franchise3"]');
    if (!seg) return;
    var btns = Array.prototype.slice.call(seg.querySelectorAll('button'));
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-franchise3') || '';
        if (key === state.franchise) return;
        state.franchise = key;
        setFranchiseUI(el, key);
        persist(state);
        resetAddButton(el, ctx, state);
        clearRefreshMsg(el);
        updateBasket(el, ctx, state, false);
      });
    });
  }

  function wireSlider(el, ctx, state) {
    var input = el.querySelector('[data-cws-slider]');
    if (!input) return;
    input.addEventListener('input', function () {
      var pos = parseInt(input.value, 10) / 1000;
      state.budget = Math.max(SLIDER_MIN, Math.min(SLIDER_MAX, budgetFromPos(pos)));
      setBudgetDisplay(el, state, false);
      updateFillBar(el, state);
      clearTimeout(state.sliderDebounceTimer);
      /* tijdens het slepen stellen we de samenstelling niet bij elke stap opnieuw samen:
         pas na ongeveer 180 ms stilstand (of bij loslaten, via "change") volgt de carrousel */
      state.sliderDebounceTimer = setTimeout(function () { commitBudgetSettled(el, ctx, state); }, SLIDER_DEBOUNCE_MS);
    });
    input.addEventListener('change', function () {
      clearTimeout(state.sliderDebounceTimer);
      commitBudgetSettled(el, ctx, state);
    });
  }
  function commitBudgetSettled(el, ctx, state) {
    persist(state);
    resetAddButton(el, ctx, state);
    clearRefreshMsg(el);
    updateBasket(el, ctx, state, false);
  }

  function applyBudget(el, ctx, state, newBudget) {
    state.budget = Math.max(10, Math.min(2000, newBudget));
    persist(state);
    resetAddButton(el, ctx, state);
    clearRefreshMsg(el);
    var sliderInput = el.querySelector('[data-cws-slider]');
    if (sliderInput) sliderInput.value = Math.round(posFromBudget(state.budget) * 1000);
    updateBasket(el, ctx, state, false);
  }

  /* eigen bedrag: het grote bedrag zelf wordt een tekstveld (geen number-spinners), met
     dezelfde typografie, een groeiende breedte (meet-span), een onderstreping in plaats van
     een witte doos, en een klein rond bevestigknopje. Enter of de knop bevestigt, Escape
     annuleert, blur bevestigt ook. */
  function wireCustomAmount(el, ctx, state) {
    var t = strFor(ctx.lang);
    var valBtn = el.querySelector('[data-cws-val-btn]');
    var wrap = el.querySelector('[data-cws-custom-wrap]');
    var input = el.querySelector('[data-cws-custom-input]');
    var confirmBtn = el.querySelector('[data-cws-custom-confirm]');
    var hint = el.querySelector('[data-cws-custom-hint]');
    if (!valBtn || !wrap || !input) return;

    function sizeInput() {
      var len = Math.max(1, String(input.value || '').length);
      input.style.width = (len + 0.2) + 'ch'; /* Anton-cijfers zijn tabular, 1ch per cijfer + lucht voor de cursor */
    }
    function parseVal() {
      var raw = String(input.value || '').replace(',', '.').replace(/[^0-9.]/g, '');
      var v = parseFloat(raw);
      return isNaN(v) ? null : Math.round(v);
    }
    function validate() {
      var v = parseVal();
      var valid = v != null && v >= 10 && v <= 2000;
      if (hint) hint.classList.toggle('cws-invalid', !valid && v != null);
      return valid ? v : null;
    }
    function openCustom() {
      input.value = String(state.budget);
      valBtn.hidden = true;
      wrap.hidden = false;
      if (hint) { hint.hidden = false; hint.classList.remove('cws-invalid'); }
      sizeInput();
      input.focus();
      input.select();
    }
    function closeCustom() {
      wrap.hidden = true;
      valBtn.hidden = false;
      if (hint) hint.hidden = true;
    }
    function confirmCustom() {
      if (wrap.hidden) return;
      var v = parseVal();
      if (v == null) v = state.budget;
      v = Math.max(10, Math.min(2000, v));
      closeCustom();
      applyBudget(el, ctx, state, v);
    }
    function cancelCustom() { closeCustom(); }

    valBtn.addEventListener('click', openCustom);
    input.addEventListener('input', function () {
      var raw = String(input.value || '');
      var cleaned = raw.replace(/[^0-9,.]/g, '');
      var seenSep = false;
      cleaned = cleaned.split('').filter(function (ch) {
        if (ch === ',' || ch === '.') { if (seenSep) return false; seenSep = true; return true; }
        return true;
      }).join('');
      if (cleaned !== raw) input.value = cleaned;
      sizeInput();
      validate();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); confirmCustom(); }
      else if (e.key === 'Escape') { e.preventDefault(); cancelCustom(); }
    });
    input.addEventListener('blur', function () { confirmCustom(); });
    if (confirmBtn) confirmBtn.addEventListener('mousedown', function (e) { e.preventDefault(); });
    if (confirmBtn) confirmBtn.addEventListener('click', confirmCustom);
  }

  function clearRefreshMsg(el) {
    var msg = el.querySelector('[data-cws-refresh-msg]');
    if (msg) { msg.classList.remove('cws-show'); msg.textContent = ''; }
  }
  function showRefreshMsg(el, state, text) {
    var msg = el.querySelector('[data-cws-refresh-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.add('cws-show');
    clearTimeout(state.refreshMsgTimer);
    state.refreshMsgTimer = setTimeout(function () { msg.classList.remove('cws-show'); }, 3200);
    state.timers.push(state.refreshMsgTimer);
  }

  /* vernieuwen: altijd een andere selectie binnen hetzelfde budget en dezelfde franchise, via
     een seed die per klik ophoogt. probeert tot de set (handles plus aantallen) verschilt van
     de vorige, tot 25 pogingen; is er echt maar 1 mogelijke set, toon dan kort die boodschap. */
  function wireRefresh(el, ctx, state) {
    var t = strFor(ctx.lang);
    var btn = el.querySelector('[data-cws-refresh]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var prevSig = basketSignature(state.lastItems);
      /* "Andere selectie" vervangt de selectie wel en wist de eigen-status (eigenaar 5 okt) */
      state.isManual = false; state.manualItems = null; state.replaceSeen = {};
      var attempts = 0, found = false, seed = state.seed, result = null;
      while (attempts < 25) {
        seed = seed + 1;
        result = composeFor(ctx, { budget: state.budget, franchise: state.franchise, typePrefs: state.typePrefs }, ctx.products, seed);
        attempts++;
        if (basketSignature(result.items) !== prevSig) { found = true; break; }
      }
      state.seed = seed;
      persist(state);
      resetAddButton(el, ctx, state);
      if (!el.classList.contains('cws-reduced')) {
        btn.classList.remove('cws-spin'); void btn.offsetWidth; btn.classList.add('cws-spin');
      }
      if (found) clearRefreshMsg(el); else showRefreshMsg(el, state, t.onlyOne);
      updateBasket(el, ctx, state, false);
    });
  }

  /* "Zet in mandje" (eigenaar 6 okt, bevestigingsstaat): geen tijdelijke 1,5s-terugval meer.
     De knop blijft "In je mandje" (met vinkje) en uitgeschakeld, en de carrousel toont de
     bevestigingskaart, tot er echt iets aan de selectie verandert (resetAddButton ruimt dat
     overal al op, zie daar). Koopbalk-totaal en "N producten" blijven gewoon staan: de
     selectie zelf verandert niet door toe te voegen, dus ze tonen al precies wat er net
     toegevoegd werd (gekozen variant, in plaats van ze naar 0 te laten gaan). */
  function wireAddMany(el, ctx, state) {
    var t = strFor(ctx.lang);
    var btn = el.querySelector('[data-cws-addmany]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (!state.lastItems.length) return;
      /* geen dubbel toevoegen: staat de bevestiging al voor exact deze selectie, dan doet een
         nieuwe klik niets (de knop oogt trouwens al uitgeschakeld) */
      if (state.confirmed && basketSignature(state.confirmed.items) === basketSignature(state.lastItems)) return;
      var items = state.lastItems.map(function (it) { return { handle: it.handle, qty: it.qty }; });
      if (ctx.on && ctx.on.addMany) ctx.on.addMany(items);
      if (state.addTimer) { clearTimeout(state.addTimer); state.addTimer = null; }
      state.confirmed = {
        items: cloneManualItems(state.lastItems), total: manualTotal(state.lastItems),
        count: state.lastItems.reduce(function (s, it) { return s + it.qty; }, 0),
        budget: state.budget, franchise: state.franchise, seed: state.seed,
        isManual: state.isManual, manualItems: state.isManual ? cloneManualItems(state.manualItems) : null
      };
      btn.classList.add('cws-done');
      btn.setAttribute('aria-disabled', 'true');
      var ic = btn.querySelector('[data-cws-addmany-ic]'), lbl = btn.querySelector('[data-cws-addmany-lbl]');
      if (ic) ic.innerHTML = icon('check', 'cws-check');
      if (lbl) lbl.textContent = t.added;
      showConfirmCard(el, ctx, state);
    });
  }

  /* ---------------- bevestigingskaart: "Stel een nieuwe samen" (CARDIX stelt meteen een
     nieuwe selectie samen, zelfde budget en franchise, zonder de net toegevoegde producten),
     "Bekijk mijn mandje" (opent/toont het mandje, ctx.on.openCart) en "Ongedaan maken" (haalt
     exact die aantallen weer uit het mandje en zet de vorige selectie terug). ---------------- */
  function wireConfirmActions(el, ctx, state) {
    var card = el.querySelector('[data-cws-car-confirm]');
    if (!card) return;
    var newBtn = card.querySelector('[data-cws-confirm-new]');
    var cartBtn = card.querySelector('[data-cws-confirm-cart]');
    var undoBtn = card.querySelector('[data-cws-confirm-undo]');
    if (newBtn) newBtn.addEventListener('click', function () {
      if (!state.confirmed) return;
      var excludeHandles = state.confirmed.items.map(function (it) { return it.handle; });
      var prevSig = basketSignature(state.lastItems);
      var filtered = (ctx.products || []).filter(function (p) { return excludeHandles.indexOf(p.handle) === -1; });
      var seed = state.seed, result = null, attempts = 0;
      while (attempts < 25) {
        seed = seed + 1;
        result = composeFor(ctx, { budget: state.budget, franchise: state.franchise, typePrefs: state.typePrefs }, filtered, seed);
        attempts++;
        if (basketSignature(result.items) !== prevSig) break;
      }
      state.seed = seed;
      state.isManual = false; state.manualItems = null; state.replaceSeen = {};
      persist(state);
      resetAddButton(el, ctx, state);
      clearRefreshMsg(el);
      /* excludeHandles maar voor deze ene herberekening: currentBasket() filtert de net
         toegevoegde producten weg, direct erna weer leeg zodat latere wijzigingen (budget,
         franchise, Andere selectie) weer de volledige pool gebruiken */
      state.excludeHandles = excludeHandles;
      updateBasket(el, ctx, state, false);
      state.excludeHandles = null;
    });
    if (cartBtn) cartBtn.addEventListener('click', function () {
      if (ctx.on && ctx.on.openCart) ctx.on.openCart();
    });
    if (undoBtn) undoBtn.addEventListener('click', function () {
      if (!state.confirmed) return;
      var c = state.confirmed;
      if (ctx.on && ctx.on.removeMany) {
        ctx.on.removeMany(c.items.map(function (it) { return { handle: it.handle, qty: it.qty }; }));
      }
      /* exact de vorige selectie terug: budget, franchise, seed en een eventuele eigen
         (handmatige) selectie waren niet gewijzigd zolang de bevestiging stond */
      state.budget = c.budget; state.franchise = c.franchise; state.seed = c.seed;
      state.isManual = c.isManual; state.manualItems = c.isManual ? cloneManualItems(c.manualItems) : null;
      persist(state);
      resetAddButton(el, ctx, state);
      clearRefreshMsg(el);
      setFranchiseUI(el, state.franchise);
      var sliderInput = el.querySelector('[data-cws-slider]');
      if (sliderInput) sliderInput.value = Math.round(posFromBudget(state.budget) * 1000);
      updateBasket(el, ctx, state, false);
    });
  }

  /* ---------------- voorkeuren voor producttype: knopje + regeltje openen hetzelfde paneel
     (popover op desktop, bottom sheet op mobiel via de container-query in de CSS), met
     focus-trap, Escape en een klik ernaast om te sluiten. elke wijziging herstelt het mandje
     via updateBasket, dus met dezelfde vloeiende FLIP-overgang als budget/franchise. ---------------- */
  function wirePrefs(el, ctx, state) {
    var t = strFor(ctx.lang);
    var trigger = el.querySelector('[data-cws-prefs-btn]');
    var line = el.querySelector('[data-cws-prefs-line]');
    var panel = el.querySelector('[data-cws-prefs-panel]');
    var backdrop = el.querySelector('[data-cws-prefs-backdrop]');
    if (!trigger || !panel || !backdrop) return;

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('button')).filter(function (b) { return !b.disabled; });
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); closePanel(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    /* het paneel verhuist tijdelijk naar document.body (position:fixed): zo ontsnapt het
       altijd aan de overflow:hidden van de witte kaart (.cws-in) of een eigen stapel-context van een voorouder.
       op zijn oorspronkelijke plek terug bij het sluiten. Desktop: 420 px breed onder de knop, rechts uitgelijnd
       en binnen het venster gehouden (past het er niet onder, dan erboven); smal: bottom sheet. */
    var panelHome = panel.parentNode, panelHomeNext = panel.nextSibling;
    var backdropHome = backdrop.parentNode, backdropHomeNext = backdrop.nextSibling;
    function positionPanel() {
      var narrow = el.getBoundingClientRect().width <= 460 || window.innerWidth <= 460;
      panel.style.position = 'fixed';
      if (narrow) {
        panel.style.top = ''; panel.style.left = '0'; panel.style.right = '0'; panel.style.bottom = '0';
        panel.style.width = 'auto'; panel.style.maxWidth = 'none'; panel.style.maxHeight = '86vh';
        panel.style.borderRadius = '20px 20px 0 0';
      } else {
        var r = trigger.getBoundingClientRect();
        var w = Math.min(420, window.innerWidth - 24);
        var right = Math.round(window.innerWidth - r.right);
        right = Math.max(12, Math.min(right, window.innerWidth - w - 12));
        var below = window.innerHeight - r.bottom - 22, above = r.top - 22;
        panel.style.left = 'auto'; panel.style.width = w + 'px'; panel.style.maxWidth = 'none'; panel.style.right = right + 'px';
        panel.style.borderRadius = '';
        if (below < 460 && above > below) {
          panel.style.top = ''; panel.style.bottom = Math.round(window.innerHeight - r.top + 10) + 'px';
          panel.style.maxHeight = Math.max(240, Math.round(above)) + 'px';
        } else {
          panel.style.bottom = ''; panel.style.top = Math.round(r.bottom + 10) + 'px';
          panel.style.maxHeight = Math.max(240, Math.round(below)) + 'px';
        }
      }
      panel.style.zIndex = '99999';
      backdrop.style.position = 'fixed'; backdrop.style.inset = '0'; backdrop.style.zIndex = '99998';
    }
    function openPanel() {
      document.body.appendChild(backdrop);
      document.body.appendChild(panel);
      syncUI();
      positionPanel();
      panel.hidden = false; backdrop.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      panel.addEventListener('keydown', onKeydown);
      backdrop.addEventListener('click', closePanel);
      window.addEventListener('resize', positionPanel);
      var f = focusables();
      var cur = panel.querySelector('[data-cws-pp-who][aria-checked="true"]');
      (cur && !cur.disabled ? cur : f[0]) && (cur && !cur.disabled ? cur : f[0]).focus();
    }
    function closePanel() {
      if (panel.hidden) return;
      panel.hidden = true; backdrop.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      panel.removeEventListener('keydown', onKeydown);
      backdrop.removeEventListener('click', closePanel);
      window.removeEventListener('resize', positionPanel);
      panel.style.cssText = ''; backdrop.style.cssText = '';
      backdropHome.insertBefore(backdrop, backdropHomeNext);
      panelHome.insertBefore(panel, panelHomeNext);
      trigger.focus();
    }
    trigger.addEventListener('click', function () { if (panel.hidden) openPanel(); else closePanel(); });
    if (line) line.addEventListener('click', function () { if (panel.hidden) openPanel(); });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-cws-prefs-done]'), function (b) { b.addEventListener('click', closePanel); });

    /* wat het paneel toont: bij CARDIX de afgeleide keuzes (gedimd, niet bewerkbaar), bij zelf kiezen de eigen keuzes */
    function setOn(btn, on, attr) { btn.classList.toggle('cws-on', on); btn.setAttribute(attr || 'aria-checked', on ? 'true' : 'false'); }
    function syncUI() {
      var tp = state.typePrefs, auto = tp.mode === 'auto';
      var eff = effectiveTypePrefs(ctx, state);
      var view = auto ? { types: eff.types, style: 'mixed', purpose: 'stream', avoid: tp.avoid === true } : { types: tp.types, style: tp.style, purpose: tp.purpose, avoid: tp.avoid === true };
      panel.classList.toggle('cws-pp-auto', auto);
      var sum = panel.querySelector('[data-cws-prefs-sum]');
      if (sum) sum.textContent = prefsLineText(t, eff);
      Array.prototype.forEach.call(panel.querySelectorAll('[data-cws-pp-who]'), function (b) { setOn(b, b.getAttribute('data-cws-pp-who') === tp.mode); });
      Array.prototype.forEach.call(panel.querySelectorAll('.cws-pp-dim button'), function (b) { b.disabled = auto; });
      var counts = typeCountsFor(ctx.products, state.franchise);
      Array.prototype.forEach.call(panel.querySelectorAll('[data-cws-prefs-chip]'), function (chip) {
        var id = chip.getAttribute('data-type-id');
        setOn(chip, view.types.indexOf(id) !== -1, 'aria-pressed');
        var n = counts[id] || 0, nEl = chip.querySelector('[data-cws-chip-n]');
        if (nEl) nEl.textContent = String(n);
        chip.classList.toggle('cws-zero', n === 0);
      });
      var all = panel.querySelector('[data-cws-pp-all]');
      if (all) setOn(all, view.types.length === 0, 'aria-pressed');
      Array.prototype.forEach.call(panel.querySelectorAll('[data-cws-pp-style]'), function (b) { setOn(b, b.getAttribute('data-cws-pp-style') === view.style); });
      Array.prototype.forEach.call(panel.querySelectorAll('[data-cws-pp-purpose]'), function (b) { setOn(b, b.getAttribute('data-cws-pp-purpose') === view.purpose); });
      var avoid = panel.querySelector('[data-cws-pp-avoid]');
      if (avoid) setOn(avoid, view.avoid);
    }
    state.syncPrefsUI = syncUI;
    /* elke wijziging bewaart, wist een eigen bijgestelde selectie (de klant vraagt nu om een nieuwe samenstelling,
       anders zou currentBasket de oude handmatige regels blijven tonen) en stelt meteen opnieuw samen */
    function applyPrefsChange() {
      saveTypePrefs(state.typePrefs);
      state.isManual = false; state.manualItems = null; state.replaceSeen = {};
      resetAddButton(el, ctx, state);
      clearRefreshMsg(el);
      updateBasket(el, ctx, state, false);
      raiseBudgetForPrefs();
    }
    /* eigenaar 6 okt ("ik kies ETB's maar ik krijg andere dingen"): kiest de klant zelf een producttype dat niet in
       het budget past, dan zet de schuif zich op de goedkoopste prijs van dat type (binnen de franchise) en zegt een
       korte regel waarom. Zo krijgt de klant wat hij koos; omlaag schuiven blijft kan, dan volgt weer de terugvalregel. */
    function raiseBudgetForPrefs() {
      var tp = state.typePrefs, eff = state.lastEffPrefs;
      if (!tp || tp.mode !== 'manual' || !tp.types || !tp.types.length || !eff || !eff.types || !eff.types.length) return;
      var fb = el.querySelector('[data-cws-pref-fallback]');
      if (!fb || fb.hidden) return; /* de keuze past al in het budget */
      var from = null;
      (ctx.products || []).forEach(function (p) {
        if (!p || p.av === false || p.type === 'acc' || !productMatchesFranchise(p, state.franchise)) return;
        if (eff.types.indexOf(classifyProduct(p)) !== -1 && (from == null || p.price < from)) from = p.price;
      });
      if (from == null || from <= state.budget) return;
      var t = strFor(ctx.lang);
      /* de regel blijft enkel staan zolang het budget op dit bedrag blijft (updateBasket leest raised) */
      state.raised = { budget: Math.ceil(from), text: t.prefsRaised ? t.prefsRaised(joinCatLabels(eff.types, t, false), Math.ceil(from)) : '' };
      applyBudget(el, ctx, state, Math.ceil(from));
    }
    panel.addEventListener('click', function (e) {
      var tgt = e.target.closest ? e.target.closest('button') : null;
      if (!tgt || tgt.disabled || !panel.contains(tgt)) return;
      var tp = state.typePrefs;
      if (tgt.hasAttribute('data-cws-pp-who')) {
        var mode = tgt.getAttribute('data-cws-pp-who');
        if (mode === tp.mode) return;
        tp.mode = mode;
      } else if (tgt.hasAttribute('data-cws-prefs-chip')) {
        var id = tgt.getAttribute('data-type-id'), i = tp.types.indexOf(id);
        if (i === -1) tp.types.push(id); else tp.types.splice(i, 1);
      } else if (tgt.hasAttribute('data-cws-pp-all')) {
        if (!tp.types.length) return;
        tp.types = [];
      } else if (tgt.hasAttribute('data-cws-pp-style')) {
        tp.style = tgt.getAttribute('data-cws-pp-style');
      } else if (tgt.hasAttribute('data-cws-pp-purpose')) {
        tp.purpose = tgt.getAttribute('data-cws-pp-purpose');
      } else if (tgt.hasAttribute('data-cws-pp-avoid')) {
        tp.avoid = tp.avoid !== true;
      } else if (tgt.hasAttribute('data-cws-pp-reset')) {
        state.typePrefs = defaultTypePrefs();
      } else { return; }
      applyPrefsChange();
    });
  }

  function wireManualBanner(el, ctx, state) {
    var btn = el.querySelector('[data-cws-manual-restore]');
    if (btn) btn.addEventListener('click', function () { restoreSuggestion(el, ctx, state); });
  }

  /* ---------------- zelf een product toevoegen: zelfde portal-aanpak als Voorkeuren (ontsnapt
     aan overflow:hidden/stapel-context van de echte pagina), met een zoekveld en een lijst
     gesorteerd op relevantie (eerst de gekozen categorie, dan prijs). ---------------- */
  function wireAddPanel(el, ctx, state) {
    var t = strFor(ctx.lang);
    /* 2 ingangen naar hetzelfde paneel: de tegel in de carrousel en het kleine knopje in het
       kooppaneel (voor als de tegel buiten beeld valt) */
    var triggers = Array.prototype.slice.call(el.querySelectorAll('[data-cws-buy-addchip], [data-cws-add-tile]'));
    var trigger = triggers[0];
    var panel = el.querySelector('[data-cws-add-panel]');
    var backdrop = el.querySelector('[data-cws-add-backdrop]');
    var search = el.querySelector('[data-cws-add-search]');
    var list = el.querySelector('[data-cws-add-list]');
    if (!trigger || !panel || !backdrop || !list) return;

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('button, input')).filter(function (b) { return !b.disabled; });
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); closePanel(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    var panelHome = panel.parentNode, panelHomeNext = panel.nextSibling;
    var backdropHome = backdrop.parentNode, backdropHomeNext = backdrop.nextSibling;
    /* groot venster in het midden (desktop) of bijna schermvullend blad (gsm), nooit afgeknipt: vroeger hing het paneel
       onder de knop en viel het onderaan buiten beeld (eigenaar 5 okt). Op gsm volgt het de zichtbare viewport, zodat
       het toetsenbord de zoekbalk en de eerste resultaten niet bedekt. */
    function positionPanel() {
      var narrow = el.getBoundingClientRect().width <= 460;
      var vv = window.visualViewport;
      var vh = vv ? vv.height : window.innerHeight, vt = vv ? vv.offsetTop : 0;
      panel.style.position = 'fixed'; panel.style.maxWidth = 'none'; panel.style.maxHeight = 'none'; panel.style.right = 'auto'; panel.style.bottom = 'auto';
      if (narrow) {
        panel.style.left = '8px'; panel.style.width = 'calc(100vw - 16px)';
        panel.style.top = Math.round(vt + 8) + 'px'; panel.style.height = Math.round(vh - 16) + 'px'; panel.style.transform = '';
      } else {
        var w = Math.min(580, window.innerWidth - 32), h = Math.min(680, vh - 48);
        panel.style.width = w + 'px'; panel.style.height = h + 'px';
        panel.style.left = Math.round((window.innerWidth - w) / 2) + 'px'; panel.style.top = Math.round(vt + (vh - h) / 2) + 'px'; panel.style.transform = '';
      }
      panel.style.borderRadius = '20px';
      panel.style.zIndex = '99999';
      backdrop.style.position = 'fixed'; backdrop.style.inset = '0'; backdrop.style.zIndex = '99998'; backdrop.style.background = 'rgba(26,6,62,.38)';
    }

    /* zoeken: zonder accenten en hoofdletters, elk woord moet ergens passen (naam, set, franchise, soort, synoniemen),
       "op12" vindt ook "OP-12", 1 tikfout mag vanaf 5 letters. Filters per franchise en per soort, met aantallen. */
    var frEl = panel.querySelector('[data-cws-add-fr]'), kindEl = panel.querySelector('[data-cws-add-kind]');
    var countEl = panel.querySelector('[data-cws-add-count]'), closeBtn = panel.querySelector('[data-cws-add-close]');
    var filt = { fr: '', kind: '' };
    var CAT_SYN = { packs: 'booster pack packs pakje', blister: 'blister sleeved', bundles: 'bundle bundel', etb: 'etb elite trainer box',
      boxen: 'booster box boxen display', collecties: 'collectie collection tin box upc premium', cases: 'display case' };
    var FR_SYN = { 'Pokémon': 'pkmn ptcg', 'One Piece': 'op onepiece', 'Disney Lorcana': 'lorcana', 'Dragon Ball': 'dbs fusion' };
    function norm(x) { return String(x || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function near(a, b) { /* hoogstens 1 bewerking verschil */
      if (Math.abs(a.length - b.length) > 1) return false;
      var i = 0, j = 0, diff = 0;
      while (i < a.length && j < b.length) {
        if (a[i] === b[j]) { i++; j++; continue; }
        if (++diff > 1) return false;
        if (a.length > b.length) i++; else if (b.length > a.length) j++; else { i++; j++; }
      }
      return diff + (a.length - i) + (b.length - j) <= 1;
    }
    var INDEX = null;
    function buildIndex() {
      INDEX = (ctx.products || []).filter(function (p) { return p && p.av !== false && p.type !== 'acc'; }).map(function (p) {
        var cat = classifyProduct(p);
        var name = norm(shortTitle(p.title));
        var all = norm([p.title, p.franchise, FR_SYN[p.franchise] || '', p.kind, kindLabel(ctx, p.handle), cat ? t.prefCat[cat] : '', cat ? CAT_SYN[cat] : ''].join(' '));
        return { p: p, cat: cat, name: name, nameWords: name.split(' '), words: all.split(' '), compact: all.replace(/ /g, '') };
      });
    }
    function tokenScore(e, tok) {
      if (e.nameWords.some(function (w) { return w.indexOf(tok) === 0; })) return 3;
      if (e.words.some(function (w) { return w.indexOf(tok) === 0; })) return 2;
      if (e.compact.indexOf(tok) !== -1) return 1;
      if (tok.length >= 5 && e.words.some(function (w) { return w.length >= 4 && (near(w, tok) || near(w.slice(0, tok.length), tok)); })) return 1;
      return 0;
    }
    function frLabel(f) { return f === 'Disney Lorcana' ? 'Lorcana' : f; }
    function chip(label, n, on, key, val) {
      return '<button type="button" class="cws-add-chip' + (on ? ' cws-on' : '') + '" data-' + key + '="' + esc(val) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
        esc(label) + (n != null ? '<span class="cws-add-chip-n">' + n + '</span>' : '') + '</button>';
    }
    function renderList(filterText) {
      if (!INDEX) buildIndex();
      var toks = norm(filterText).split(' ').filter(Boolean);
      var eff = effectiveTypePrefs(ctx, state);
      var prefIds = eff.types || [];
      var used = {}; (state.lastItems || []).forEach(function (it) { used[it.handle] = (used[it.handle] || 0) + 1; });
      /* eerst enkel op de zoekterm, dan per filter: zo tonen de chips hoeveel er bij die keuze overblijven */
      var hits = [];
      INDEX.forEach(function (e) {
        var sc = 0;
        for (var i = 0; i < toks.length; i++) { var k = tokenScore(e, toks[i]); if (!k) return; sc += k; }
        hits.push({ e: e, sc: sc });
      });
      var frCount = {}, kindCount = {};
      hits.forEach(function (h) {
        if (!filt.kind || h.e.cat === filt.kind) frCount[h.e.p.franchise] = (frCount[h.e.p.franchise] || 0) + 1;
        if (!filt.fr || h.e.p.franchise === filt.fr) { if (h.e.cat) kindCount[h.e.cat] = (kindCount[h.e.cat] || 0) + 1; }
      });
      var frs = {}; INDEX.forEach(function (e) { frs[e.p.franchise] = (frs[e.p.franchise] || 0) + 1; });
      var frOrder = Object.keys(frs).sort(function (a, b) { return frs[b] - frs[a]; });
      if (frEl) frEl.innerHTML = chip(t.addAllFr, null, !filt.fr, 'fr', '') + frOrder.map(function (f) { return chip(frLabel(f), frCount[f] || 0, filt.fr === f, 'fr', f); }).join('');
      if (kindEl) kindEl.innerHTML = chip(t.addAllKinds, null, !filt.kind, 'kind', '') + TYPE_CAT_DEFS.filter(function (d) { return INDEX.some(function (e) { return e.cat === d.id; }); })
        .map(function (d) { return chip(t.prefCat[d.id] || d.id, kindCount[d.id] || 0, filt.kind === d.id, 'kind', d.id); }).join('');
      var pool = hits.filter(function (h) { return (!filt.fr || h.e.p.franchise === filt.fr) && (!filt.kind || h.e.cat === filt.kind); });
      pool.sort(function (a, b) {
        if (a.sc !== b.sc) return b.sc - a.sc;
        var aF = productMatchesFranchise(a.e.p, state.franchise) ? 0 : 1, bF = productMatchesFranchise(b.e.p, state.franchise) ? 0 : 1;
        if (aF !== bF) return aF - bF;
        var aPref = prefIds.indexOf(a.e.cat) !== -1 ? 0 : 1, bPref = prefIds.indexOf(b.e.cat) !== -1 ? 0 : 1;
        if (aPref !== bPref) return aPref - bPref;
        return a.e.p.price - b.e.p.price;
      });
      if (countEl) countEl.textContent = t.addCount(pool.length);
      list.innerHTML = '';
      if (!pool.length) {
        var empty = document.createElement('div');
        empty.className = 'cws-add-empty';
        empty.textContent = t.addEmpty;
        list.appendChild(empty);
        return;
      }
      var remaining = Math.max(0, round2(state.budget - manualTotal(state.isManual ? state.manualItems : (state.lastItems || []))));
      var frag = document.createDocumentFragment();
      pool.forEach(function (h) {
        var p = h.e.p;
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'cws-add-row';
        var overBudget = p.price > remaining + 1e-9;
        var kl = kindLabel(ctx, p.handle);
        row.innerHTML = '<img class="cws-add-row-thumb" src="' + esc(ctx.img(p.handle)) + '" alt="" loading="lazy">' +
          '<span class="cws-add-row-info"><span class="cws-add-row-name">' + esc(shortTitle(p.title)) + '</span>' +
          '<span class="cws-add-row-type">' + esc([frLabel(p.franchise), kl].filter(Boolean).join(' · ')) + '</span></span>' +
          '<span class="cws-add-row-price">' + eurHtml(p.price) + '</span>' +
          (overBudget ? '<span class="cws-add-row-over">' + esc(t.overBudgetChip) + '</span>' : '') +
          (boughtSetOf(ctx)[p.handle] ? '<span class="cws-bought">' + esc(t.boughtChip) + '</span>' : '') +
          '<span class="cws-add-row-plus" aria-hidden="true">' + icon('plus') + '</span>';
        row.setAttribute('aria-label', t.addPlusAria(p.title || ''));
        if (used[p.handle]) row.classList.add('cws-on');
        row.addEventListener('click', function () {
          addToManual(ctx, state, p.handle);
          resetAddButton(el, ctx, state);
          updateBasket(el, ctx, state, false);
          var keep = list.scrollTop;
          renderList(search ? search.value : '');
          list.scrollTop = keep;
        });
        frag.appendChild(row);
      });
      list.appendChild(frag);
    }
    panel.addEventListener('click', function (e) {
      var c = e.target.closest('[data-fr], [data-kind]'); if (!c || !panel.contains(c)) return;
      if (c.hasAttribute('data-fr')) filt.fr = c.getAttribute('data-fr'); else filt.kind = c.getAttribute('data-kind');
      list.scrollTop = 0; renderList(search ? search.value : '');
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { closePanel(); });
    function openPanel(fromTrigger) {
      state.addTriggerEl = fromTrigger || trigger;
      document.body.appendChild(backdrop);
      document.body.appendChild(panel);
      positionPanel();
      if (search) search.value = '';
      filt.fr = ''; filt.kind = ''; INDEX = null;
      renderList('');
      panel.hidden = false; backdrop.hidden = false;
      if (window.visualViewport) { window.visualViewport.addEventListener('resize', positionPanel); window.visualViewport.addEventListener('scroll', positionPanel); }
      triggers.forEach(function (tr) { tr.setAttribute('aria-expanded', 'true'); });
      panel.addEventListener('keydown', onKeydown);
      backdrop.addEventListener('click', closePanel);
      window.addEventListener('resize', positionPanel);
      /* op gsm niet meteen het toetsenbord openen: eerst de chips en de lijst tonen, tik op het zoekveld als je wil typen */
      if (search && el.getBoundingClientRect().width > 460) search.focus(); else { var f = focusables(); if (f.length) f[0].focus({ preventScroll: true }); }
    }
    function closePanel() {
      if (panel.hidden) return;
      panel.hidden = true; backdrop.hidden = true;
      triggers.forEach(function (tr) { tr.setAttribute('aria-expanded', 'false'); });
      panel.removeEventListener('keydown', onKeydown);
      backdrop.removeEventListener('click', closePanel);
      window.removeEventListener('resize', positionPanel);
      if (window.visualViewport) { window.visualViewport.removeEventListener('resize', positionPanel); window.visualViewport.removeEventListener('scroll', positionPanel); }
      panel.style.cssText = ''; backdrop.style.cssText = '';
      backdropHome.insertBefore(backdrop, backdropHomeNext);
      panelHome.insertBefore(panel, panelHomeNext);
      if (state.addTriggerEl && state.addTriggerEl.isConnected) state.addTriggerEl.focus();
      state.addTriggerEl = null;
    }
    triggers.forEach(function (tr) {
      tr.addEventListener('click', function () { if (panel.hidden) openPanel(tr); else closePanel(); });
    });
    if (search) search.addEventListener('input', function () { renderList(search.value); });
  }

  function wireScroll(el, ctx) {
    var btn = el.querySelector('[data-cws-scroll]');
    if (btn) btn.addEventListener('click', function () { if (ctx.on && ctx.on.scroll) ctx.on.scroll(); });
  }

  /* pijlen schuiven 1 product per klik (scroll-snap vangt de rest op); de teller en de
     pijl-status volgen elke scrollbeweging, ook een sleep of swipe. */
  function wireCarousel(el, ctx, state) {
    var box = el.querySelector('[data-cws-stackbox]');
    var track = el.querySelector('[data-cws-stack]');
    var prev = el.querySelector('[data-cws-car-prev]');
    var next = el.querySelector('[data-cws-car-next]');
    if (!box || !track) return;
    /* een absoluut doel per index in plaats van een relatieve scrollBy, en nooit twee
       vloeiende scrollTo's tegelijk: bij snel na elkaar klikken op de pijl raakte de
       browser de voortgang kwijt (scroll-snap onderbreekt een nieuwe scrollTo terwijl de
       vorige nog loopt). we houden daarom maar 1 "lopende" scroll bij; een nieuwe klik zet
       enkel het gewenste doel (carWantIdx), en pas als de vorige beweging echt stilvalt
       (geen scroll-events meer gedurende CAR_SETTLE_MS) scrollen we door naar het laatste
       gewenste doel. Een echte sleep/swipe van de gebruiker wint altijd. */
    var CAR_SETTLE_MS = 140;
    var settleTimer = null;
    var rafCtl = null;

    function clampIdx(idx) {
      var n = (track.__cwsKeys || []).length;
      var maxIdx = Math.max(0, n - 1);
      return Math.max(0, Math.min(maxIdx, idx));
    }
    function doScroll(idx) {
      var maxScroll = Math.max(0, track.scrollWidth - box.clientWidth);
      var target = Math.min(stackLeft(track, idx), maxScroll);
      /* al op het doel (einde van de rij): er komt geen scroll-event, dus meteen afronden i.p.v. vast te blijven */
      if (Math.abs(target - track.scrollLeft) < 1) { state.carAnimating = false; state.carWantIdx = stackIdxAt(track); updateCarouselControls(el, box, track, state); return; }
      state.carAnimating = true;
      track.scrollTo({ left: target, behavior: state.reduced ? 'auto' : 'smooth' });
    }
    function go(dir) {
      var cur = state.carWantIdx != null ? state.carWantIdx : stackIdxAt(track);
      var idx = clampIdx(cur + dir);
      state.carWantIdx = idx;
      if (!state.carAnimating) doScroll(idx);
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    /* een echte aanraking/sleep op de baan zelf heeft altijd voorrang: een nog ingestelde
       pijl-doel mag de hand van de gebruiker nooit "corrigeren". */
    function userTakesOver() {
      state.carWantIdx = null;
      state.carAnimating = false;
      clearTimeout(settleTimer);
    }
    track.addEventListener('pointerdown', userTakesOver);
    /* trackpad/muiswiel (Mac-swipe) geeft geen pointerdown: zonder dit trok de afloop-timer de baan na een swipe
       terug naar het vorige pijl-doel, "blijft niet waar ik stop" (eigenaar 5 okt) */
    track.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > 0 || e.shiftKey) userTakesOver(); }, { passive: true });

    track.addEventListener('scroll', function () {
      if (!rafCtl) {
        rafCtl = requestAnimationFrame(function () {
          rafCtl = null;
          updateCarouselControls(el, box, track, state);
        });
      }
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        var curIdx = stackIdxAt(track);
        /* enkel doorschuiven als een pijlklik nog een doel heeft; na een eigen sleep/swipe nooit corrigeren */
        if (state.carAnimating && state.carWantIdx != null && state.carWantIdx !== curIdx) {
          /* er kwam nog een klik binnen tijdens het scrollen: ga door naar het laatste doel */
          doScroll(state.carWantIdx);
          return;
        }
        state.carWantIdx = curIdx;
        state.carAnimating = false;
      }, CAR_SETTLE_MS);
    });
  }

  /* klik versus vasthouden/slepen, voor zowel de Stage3D-items (ctx.mount3D) als de
     sleepbare uitsnedes: enkel een echte korte klik (< 250 ms, < 6 px beweging) opent het
     product. werkt voor muis en touch (pointer-events), en onderdrukt ook de click die de
     browser erna nog afvuurt als het wel een sleep was. */
  function wireClickVsDrag(target, state, onClick) {
    var down = false, sx = 0, sy = 0, st = 0, moved = 0, suppress = false;
    target.addEventListener('pointerdown', function (e) {
      down = true; moved = 0; st = e.timeStamp || now();
      sx = e.clientX; sy = e.clientY; suppress = false;
    });
    target.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      var d = Math.sqrt(dx * dx + dy * dy);
      if (d > moved) moved = d;
    });
    function up(e) {
      if (!down) return;
      down = false;
      var dur = (e.timeStamp || now()) - st;
      if (dur < 250 && moved < 6) { if (onClick) onClick(e); }
      else { suppress = true; }
    }
    target.addEventListener('pointerup', up);
    target.addEventListener('pointercancel', function () { down = false; });
    target.addEventListener('click', function (e) {
      if (suppress) { e.preventDefault(); e.stopPropagation(); suppress = false; }
    }, true);
  }

  /* losse uitsnede (zonder mount3D) los kunnen draaien: slepen geeft rotateY met een lichte
     traagheid, loslaten veert terug naar 0. enkel het visuele effect; de klik-vs-sleep-
     beslissing zit los in wireClickVsDrag. */
  function wireRotateVisual(imgzone, state, skip) {
    var dragging = false, sx = 0;
    imgzone.addEventListener('pointerdown', function (e) {
      if (state.reduced || (skip && skip())) return;
      dragging = true; sx = e.clientX;
      imgzone.classList.add('cws-dragging');
      if (imgzone.setPointerCapture) { try { imgzone.setPointerCapture(e.pointerId); } catch (e2) { /* negeren */ } }
    });
    imgzone.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - sx;
      var rotY = Math.max(-55, Math.min(55, dx * 0.5));
      imgzone.style.setProperty('--cws-item-roty', rotY.toFixed(2) + 'deg');
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      imgzone.classList.remove('cws-dragging');
      imgzone.style.setProperty('--cws-item-roty', '0deg');
    }
    imgzone.addEventListener('pointerup', endDrag);
    imgzone.addEventListener('pointercancel', endDrag);
    imgzone.addEventListener('pointerleave', function () { if (dragging) endDrag(); });
  }

  function replay(root) {
    var el = findRoot(root);
    if (!el) return;
    var state = getState(el);
    if (!state) return;
    playIntro(el, state.reduced);
  }

  function unmount(root) {
    var el = findRoot(root);
    if (!el) return;
    var state = getState(el);
    if (state) {
      (state.timers || []).forEach(function (id) { clearTimeout(id); });
      clearTimeout(state.sliderDebounceTimer);
      if (state.resizeObserver) { try { state.resizeObserver.disconnect(); } catch (e) { /* negeren */ } }
      if (state.segObserver) { try { state.segObserver.disconnect(); } catch (e) { /* negeren */ } }
      if (state.mount3DCtls) {
        Object.keys(state.mount3DCtls).forEach(function (k) {
          var ctl = state.mount3DCtls[k];
          if (ctl && typeof ctl.destroy === 'function') { try { ctl.destroy(); } catch (e) { /* stil negeren */ } }
        });
      }
    }
    setState(el, null);
  }

  window.CWStart = { html: html, mount: mount, replay: replay, unmount: unmount };
})();

